<template>
	<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
		<el-tab-pane label="采购需求" name="first">
			<div class="information">
				<el-form :model="ruleForm" ref="ruleForm" label-width="100px" style="overflow: hidden;"
					class="demo-ruleForm border-bottom margin-top2">
					<el-collapse-transition>
						<div v-show="showFilter">
							<el-col :span="6">
								<el-form-item label="选择店铺" prop="shopName">
									<el-select v-model="ruleForm.shopName" placeholder="请选择" filterable @change="shopChange">
										<el-option v-for="item in ShopList" :key="item.shop_name" :label="item.shopName" :value="item.shopId" :style="{ color: item.state1 === 0 ? 'red' : '' }">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="采购需求状态" prop="status">
									<el-select v-model="ruleForm.status" placeholder="请选择" @change="PurchasingStatus" clearable >
										<el-option v-for="item in OrderList" :key="item.value" :label="item.label" :value="item.label">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="采购类型" prop="type">
									<el-select v-model="ruleForm.type" placeholder="请选择" @change="ProcurementType" clearable>
										<el-option v-for="item in PaymentList" :key="item.value" :label="item.label" :value="item.label">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="提交类型" prop="type">
									<el-select v-model="ruleForm.buttonStatus" placeholder="请选择" clearable>
										<el-option v-for="item in SubList" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="国家" prop="countryMark">
									<el-select v-model="ruleForm.countryMark" filterable>
										<el-option
											v-for="item in listCountry"
											:key="item.id"
											:label="item.countryName"
											:value="item.countryCode"
										></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							
							<el-col :span="6">
								<el-form-item label="开始日期" prop="startTimeString">
									<el-date-picker v-model="ruleForm.startTimeString" align="right" type="datetime" placeholder="选择开始日期"
										format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="结束日期" prop="endTimeString">
									<el-date-picker v-model="ruleForm.endTimeString" align="right" type="datetime" placeholder="选择结束日期"
										format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="拦截状态" prop="outInterceptStatus">
									<el-radio-group v-model="ruleForm.outInterceptStatus">
										<el-radio :label="0">未拦截</el-radio>
										<el-radio :label="1">拦截</el-radio>
										<el-radio :label="2">全部</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="时间类型" prop="timeType">
									<el-radio-group v-model="ruleForm.timeType">
										<el-radio :label="1">下单日期</el-radio>
										<el-radio :label="2">提采购需求日期</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="国内运单状态" style="width:100%;">
									<el-radio-group v-model="ruleForm.resource3" @change="radiochange3">
										<el-radio v-for="item in this.colorList2" :key="item.id" :label="item.itemTypeId">{{ item.itemTypeName }}</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
						</div>
					</el-collapse-transition>
					

					<el-col :span="16">
						<el-form-item prop="searchInput" class="search-input">
							<el-input v-model="ruleForm.searchString" placeholder="全字段搜索" ></el-input>
							<el-input v-model.trim="ruleForm.searchString2s" placeholder="多个订单号搜索以空格隔开"
								@change="searchForm1"
							></el-input>
							<el-button type="primary" @click="searchForm" style="margin-left:10px;">搜索</el-button>
							<el-button type="primary" @click="resetFprm">重置</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item>
							<el-button type="primary" @click="delivery">采购发货地址</el-button>
							<el-button type="warning" @click="showFilter=!showFilter">{{ showFilter?'隐藏筛选条件':'显示筛选条件' }}</el-button>
						</el-form-item>
					</el-col>
				</el-form>

				<el-dialog title="仓库地址" :visible.sync="deliveryAddress" width="30%">
					<el-table :data="warehouseAddress" style="width: 100%">
						<!-- <el-table-column prop="warehouseName" label="仓库名称" align="center"></el-table-column> -->
						<el-table-column prop="warehouseName" label="收货编码" align="center">
							<template>
								{{ str.company.partialHarvestCode }}
							</template>
						</el-table-column>
						<!-- <el-table-column label="收件人" align="center">
                                <template>
                                    <div>{{this.str.company.chineseShortName}}</div>
                                    <div>{{this.str.company.companyCode}}</div>
                                </template>
                            </el-table-column> -->
						<el-table-column prop="telephone" label="收件人电话" align="center"></el-table-column>
						<el-table-column prop="chineseAddress" label="仓库地址" align="center"></el-table-column>
					</el-table>
					<span slot="footer" class="dialog-footer">
						<el-button @click="deliveryAddress = false">取 消</el-button>
						<el-button type="primary" @click="deliveryAddress = false">确 定</el-button>
					</span>
				</el-dialog>
				<div class="table-body">
					<div class="table-batch">
						<el-dropdown trigger="click" @command="handleCommand3" style="margin-left:30px;">
							<el-button type="primary" :disabled="colordisabled">
								国内单标记<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<div v-for="item in this.colorList2" :key="item.id">
									<el-dropdown-item :command="item.itemTypeId">{{
									item.itemTypeName
									}}</el-dropdown-item>
								</div>
							</el-dropdown-menu>
						</el-dropdown>
						<el-button type="primary" :disabled="colordisabled" v-if="showTuiBool" style="margin-left: 20px"
							@click="purchaseAll">
							批量采购
						</el-button>
						<el-button type="primary" :disabled="colordisabled" v-if="showTuiBool" style="margin-left: 20px" @click="purchaseMore">
							批量sku采购
						</el-button>
						<el-button type="primary" :disabled="colordisabled" v-if="showTuiBool" style="margin-left: 20px" @click="batchMatchInventory">
								批量匹配库存
							</el-button>
					</div>
					<div class="table-list">
						<el-table ref="table1" :data="tableData" :header-cell-style="headClass" border v-loading="loading"
							style="width: 100%;margin-bottom:50px;" @selection-change="handleSelectionChange">
							<el-table-column type="selection" width="55" align="center"></el-table-column>
							<el-table-column prop="id" width="100" label="主键" sortable align="center"></el-table-column>
							<el-table-column align="left" width="280" label="订单号/订单ID">
								<template slot-scope="scope">
									<p v-show="scope.row.orderNumber">订单编码：{{ scope.row.orderNumber }}</p>
									<p>订单ID：{{ scope.row.orderId }}</p>
									<p>订单号：{{ scope.row.amazonOrderId }}</p>
									<p>
										订单状态：<span :style="{
											color:
												scope.row.orderStatus ==
												'未发货'
													? 'red'
													: 'black',
										}">{{ scope.row.orderStatus }}</span>
									</p>
									<p>国家：{{ scope.row.countryName }}</p>
									<p>
										<el-tag style="margin-right:5px;"
											:color="scope.row.orderMark?colorList3[Number(scope.row.orderMark)-1].itemName:'#fff'"
											effect="dark" size="mini" v-if="scope.row.orderMark">
											{{scope.row.orderMark?colorList3[Number(scope.row.orderMark)-1].itemTypeName:''}}
										</el-tag>
										<el-tag style="margin-right:5px;"
											:color="scope.row.orderType?colorList4[scope.row.orderType].itemName:'#fff'"
											effect="dark" size="mini" v-if="scope.row.orderType">
											{{scope.row.orderType?colorList4[scope.row.orderType].itemTypeName:''}}
										</el-tag>
										<el-tag style="margin-left:5px;" v-if="
											scope.row.outInterceptStatus ==
												1
										" color="red" effect="dark" size="mini">
											拦截
										</el-tag>
									</p>
									<p>
										<el-tooltip class="item" effect="dark" :content="
											'采购要求：' +
												scope.row.purchaseDemand
										" placement="right">
											<i class="el-icon-s-promotion" style="font-size: 17px;cursor: pointer;"></i>
										</el-tooltip>
									</p>
									<el-row type="flex" align="middle">
										<el-tag style="margin-left:5px;" closable @close="
											handleClose3(scope.row, tag)
										" v-for="tag in scope.row
											.orderPurchaseMarkItems" :color="tag.itemName" :key="tag.id" effect="dark" size="mini" :type="tag.type">
											{{ tag.itemTypeName }}
										</el-tag>
									</el-row>
								</template>
							</el-table-column>
							<el-table-column label="产品信息" width="250">
								<template slot-scope="scope">
									<div class="details td_detail" v-for="(item, index) in scope.row.productInfos" :key="item.id" :class="'product-row-' + scope.$index + '-' + index">
										<div class="details_left">
											<el-popover trigger="hover" placement="right" style="float: left;">
												<img :src="item.imageUrl" class="prduct_img" alt />
												<div class="scope_img" slot="reference">
													<img :src="item.imageUrl" alt />
												</div>
											</el-popover>
										</div>
										<div class="details_right">
											<span>
												<div>
													<strong>价格：</strong>{{ item.itemAmount }}
													{{ item.itemCurrencyCode }}
												</div>
												<div><strong>SKU：</strong>{{ item.sku }}</div>
												<div><strong>数量: </strong>{{ item.quantityOrdered }}</div>
												<div v-if="item.variantSkuList && item.variantSkuList.length"><strong>商品主SKU：</strong>{{ item.variantSkuList.join(',') }}</div>
											</span>
										</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="可用库存" width="250">
								<template slot-scope="scope">
									<div class="details12 td_detail" v-for="(item, index) in scope.row.inventoryInfo" :key="index" :class="'inventory-row-' + scope.$index + '-' + index">
										<template v-if="item.actualCount.length == 0">
											<div>无数据</div>
										</template>
										<template v-else>
											<div class="item1" v-for="(item1, index1) in item.actualCount" :key="index1">
												{{ item1.productSimpleName }}：
												<span :style="{color: item1.actualCount == 0 ? 'red' : ''}">{{item1.actualCount}}</span>
											</div>
										</template>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="amountReceived" width="80" label="人民币价格[CNY]" align="center">
								<template slot-scope="scope">
									<span >{{ scope.row.amountReceived }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="purchaseDate" width="150" label="下单时间" align="center"></el-table-column>
							
							<el-table-column prop="type" width="110" label="采购类型" align="center"></el-table-column>
							<el-table-column prop="purchaseDemand" width="150" label="采购需求" align="center"></el-table-column>
							<el-table-column width="110" label="采购需求状态" align="center">
								<template slot-scope="scope">
									<div v-if="scope.row.status === '未采购'" style="color:red">
										{{ scope.row.status }}
									</div>
									<div v-if="scope.row.status === '已采购'">
										{{ scope.row.status }}
									</div>
								</template>
							</el-table-column>
							<el-table-column width="110" label="是否提交" align="center">
								<template slot-scope="scope">
									<div v-if="scope.row.buttonStatus === 0" style="color:blue">
										是
									</div>
									<div v-if="scope.row.buttonStatus === 1" style="color:red">
										否
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="shopName" width="110" label="店铺" align="center"></el-table-column>
							<el-table-column prop="userName" width="110" label="员工" align="center"></el-table-column>
							<el-table-column prop="updateTime" width="190" label="需求时间" align="center"></el-table-column>
							<el-table-column label="操作" fixed="right" class="edit" align="center" width="90">
								<template slot-scope="scope">
									<el-button type="primary" @click="edit(scope.row)">采购</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>

				<div class="page">
					<el-pagination style="margin-right:200px;" @size-change="handleSizeChange"
						@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50, 100, 200, 500, 1000]"
						:page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
				</div>
				<Orderpurchaseedit ref="Orderpurchaseedit" @refresh="refresh" />
				<!-- 批量添加采购单 -->
				<el-dialog width="40%" top="30vh" title="批量新增采购单" :visible.sync="AddinnerVisible" append-to-body>
					<el-row class="border-bottom padding">
						<el-col :span="25">
							<el-row :gutter="20">
								<el-col class="padding" :span="6">
									<el-input v-model="morePurchaseFrom.purchasePrice">
										<template slot="prepend">
											采购价:
										</template>
									</el-input>
								</el-col>
								<el-col class="padding" :span="6">
									<el-input v-model="morePurchaseFrom.rebatePrice">
										<template slot="prepend">
											<el-tooltip content="购买后,卖家返回的佣金" placement="top">
												<el-button>返佣:</el-button>
											</el-tooltip>
										</template>
									</el-input>
								</el-col>

								<el-col class="padding" :span="6">
									<el-input v-model="morePurchaseFrom.actualRefund">
										<template slot="prepend">
											实际退款:
										</template>
									</el-input>
								</el-col>
								<el-col class="padding" :span="6">
									<el-input v-model="morePurchaseFrom.otherPrice">
										<template slot="prepend">
											退款费用:
										</template>
									</el-input>
								</el-col>
							</el-row>

							<el-row :gutter="20">
								<el-col class="padding" :span="6">
									<span class="leix">类型:</span>
									<el-select v-model="morePurchaseFrom.purchaseTypeCode" placeholder="请选择" style="width: 74%;"
										class="logistics">
										<el-option v-for="item in selectType" :key="item.value" :label="item.itemTypeName"
											:value="item.itemTypeName"></el-option>
									</el-select>
								</el-col>
								<el-col class="padding" :span="6">
									<span class="leix">物流公司:</span>
									<el-select v-model="morePurchaseFrom.logisticsCompany" @change="SelectTrack17Logistics1" value-key="id" filterable clearable placeholder="请选择" style="width: 57%;" class="logistics">
										<el-option v-for="item in Track17Logistics" :key="item.id" :label="item.nameCn"
											:value="item">
										</el-option>
									</el-select>
								</el-col>
								<el-col class="padding" :span="12">
									<el-input v-model.trim="morePurchaseFrom.internalConveyNumber" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
										<template slot="prepend">
											运单号码:
										</template>
									</el-input>
								</el-col>
							</el-row>
							<el-row>
								<el-col class="padding" :span="24">
									<el-input v-model="morePurchaseFrom.remark">
										<template slot="prepend">
											<el-tooltip content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见" placement="top">
												<el-button>采购备注:</el-button>
											</el-tooltip>
										</template>
									</el-input>
								</el-col>
							</el-row>
						</el-col>
					</el-row>

					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="AddPurchaseb" :loading="isLoading">确定</el-button>
						<el-button @click="AddinnerVisible=false">取消</el-button>
					</div>
				</el-dialog>
				<el-dialog width="40%" top="5vh" title="批量采购" :visible.sync="purchaseMoreVisible" append-to-body>
					<el-table :data="moreTableData" border v-loading="moreLoading">
						<el-table-column width="80" label="序号" align="center" type="index"></el-table-column>
						<el-table-column label="产品信息" width="250" header-align="center">
							<template slot-scope="scope">
								<div class="details">
									<div class="details_left">
										<el-popover trigger="hover" placement="right" style="float: left;">
											<img :src="scope.row.systemVariantDetailVO.variantImages" class="prduct_img" alt />
											<div class="scope_img" slot="reference">
												<img :src="scope.row.systemVariantDetailVO.variantImages" alt />
											</div>
										</el-popover>
									</div>
									<div class="details_right">
										<span>
											<div><strong>SKU：</strong>{{ scope.row.systemVariantDetailVO.variantSku }}</div>
											<div><strong>产品名称：</strong>{{ scope.row.systemVariantDetailVO.title }}</div>
										</span>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="totalQuantity" label="总计数量" align="center"></el-table-column>
						<el-table-column prop="numberOfOrder" label="包含订单数量" align="center"></el-table-column>
						<el-table-column prop="sourceUrl" label="货源链接" align="center">
							<template slot-scope="scope">
								<el-link type="primary" :underline="false" :href="scope.row.systemVariantDetailVO.sourceUrl" target="_blank">buy</el-link>
							</template>
						</el-table-column>
						<el-table-column label="操作" fixed="right" class="edit" align="center" width="80">
							<template slot-scope="scope">
								<div
									style="text-align: center;padding: 20px;"
									@click="editMore(scope.row)"
								>
									<i
										style="font-size: 20px;"
										class="el-icon-edit-outline"
									></i>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-dialog>

				<el-dialog
					top="3vh"
					width="70%"
					title="库存"
					:visible.sync="innerVisibles"
					:show-close="false"
					:close-on-click-modal="false"
					:close-on-press-escape="false"
					append-to-body>

					<el-tabs v-model="activeName" type="card">
						<el-tab-pane label="全部库存" name="first">
							<el-input
								v-model="searchString"
								placeholder="库存编号、商品全称、商品简称"
								style="width:70%;"
							></el-input>
							<el-button
								type="primary"
								style="margin-left:15px;"
								@click="matchingAjaxSearch"
								>搜索</el-button
							>
							<el-table
								:data="inventoryList"
								border
								height="450"
								style="width: 100%;margin-top:15px;"
								ref="table"
								@selection-change="handleSelectionChange1"
								v-loading="tableLoading1"
							>
								<el-table-column
									type="selection"
									width="55"
									align="center"
									:selectable="selectable"
								></el-table-column>
								<el-table-column
									prop="inventoryNumber"
									label="库存编号"
									align="center"
								></el-table-column>
								<el-table-column label="图片" align="center" width="90">
									<template slot-scope="scope">
										<el-image
											style="width: 60px; height: 60px"
											:src="scope.row.imagesList[0]"
											:preview-src-list="scope.row.imagesList"
										>
										</el-image>
									</template>
								</el-table-column>
								<el-table-column
									prop="productFullName"
									label="全称"
									align="center"
								></el-table-column>
								<el-table-column
									prop="productSimpleName"
									label="简称"
									align="center"
								></el-table-column>
								<el-table-column
									prop="inventorySku"
									label="规格尺寸"
									align="center"
								></el-table-column>
								<el-table-column
									prop="productDescription"
									label="描述"
									align="center"
								></el-table-column>
								<el-table-column
									prop="actualCount"
									label="库存数量"
									align="center"
									width="80"
								></el-table-column>
							</el-table>
							<el-pagination
								style="text-align: center;margin-top:10px;"
								@size-change="handleSizeChange3"
								@current-change="handleCurrentChange3"
								:current-page="currentPage3"
								:page-sizes="[20, 50, 100, 200]"
								:page-size="pagesize3"
								layout="total, sizes, prev, pager, next, jumper"
								:total="total3"
							></el-pagination>

							<div style="text-align: right;margin-top:10px;">
								<el-button type="primary" @click="save">保存</el-button>
							</div>
							

							<el-row style="margin-top:10px;">
								<el-table 
									:data="ReturninventoryList" 
									border  
									style="width: 100%">
									<el-table-column
										prop="inventoryNumber"
										label="库存编号"
										align="center"
									></el-table-column>
									<el-table-column label="图片" align="center" width="90">
										<template slot-scope="scope">
											<img
												:src="scope.row.images"
												alt=""
												style="width:60px;height:60px;"
											/>
										</template>
									</el-table-column>
									<el-table-column
										prop="productFullName"
										label="全称"
										align="center"
									></el-table-column>
									<el-table-column
										prop="productSimpleName"
										label="简称"
										align="center"
									></el-table-column>
									<el-table-column
										prop="inventorySku"
										label="规格尺寸"
										align="center"
									></el-table-column>
									<el-table-column
										prop="productDescription"
										label="描述"
										align="center"
									></el-table-column>
									<el-table-column
										prop="actualCount"
										label="库存数量"
										align="center"
										width="80"
									></el-table-column>
									<el-table-column label="使用数量" align="center" width="160">
										<template slot-scope="scope">
											<el-input-number
												v-model="scope.row.useCount"
												:disabled="btndisabled"
												:min="1"
												:max="calculateMax(scope.row)"
												size="mini"
											></el-input-number>
										</template>
									</el-table-column>
									<el-table-column label="核对备注" align="center">
										<template slot-scope="scope">
											<el-input
												type="textarea"
												v-model="scope.row.purchaseDemandRemark"
												:disabled="btndisabled"
											></el-input>
										</template>
									</el-table-column>
									<el-table-column
										label="操作"
										align="center"
										width="80"
										fixed="right"
									>
										<template slot-scope="scope">
											<el-button
												type="danger"
												@click="delSave(scope.row)"
												:disabled="btndisabled"
												>删除</el-button
											>
										</template>
									</el-table-column>
								</el-table>
							</el-row>

						</el-tab-pane>
					</el-tabs>

					<div slot="footer" class="dialog-footer">
						<el-button @click="cancel">取 消</el-button>
						<el-button type="primary" @click="submit" :disabled="submitdisabled"
							>提 交</el-button
						>
					</div>

					<!-- <div slot="footer" class="dialog-footer">
						<div>
							<el-button @click="innerVisibles = false">关闭</el-button>
							<el-button type="primary" @click="save">保存</el-button>
						</div>
					</div> -->
				</el-dialog>

				<el-dialog width="48%" top="5vh" title="批量增加单据" :visible.sync="billsMoreVisible" append-to-body>
					<el-row class="border-bottom padding" v-for="(item, index) in demandList" :key="index+'dd'">
						<el-col :span="25">
							<el-row :gutter="20">
								<el-col :span="5" :offset="0">
									<strong>采购需求ID:</strong>&nbsp;&nbsp;{{ item.purchaseDemandId }}
								</el-col>
								<el-col :span="6" :offset="0">
									<strong>变体标识:</strong>&nbsp;&nbsp;{{ item.productVariantMarker }}
								</el-col>
								<el-col :span="4" :offset="0">
									<strong>需求数量:</strong>&nbsp;&nbsp;{{ item.demandCount }}
								</el-col>
								<el-col :span="3" :offset="0" v-show="index == 0">
									<el-button type="primary" @click="moreSet(1)" style="margin-top: -5px;">同步单据</el-button>
								</el-col>
								<el-col :span="3" :offset="0" v-show="index == 0">
									<el-input v-model="partition" placeholder="分隔符" style="margin-top: -5px;"></el-input>
								</el-col>
								<el-col :span="3" :offset="0" v-show="index == 0">
									<el-button type="primary" @click="morePartition" style="margin-top: -5px;">分增单据</el-button>
								</el-col>
							</el-row>
							<el-row>
								<el-col class="padding" :span="24">
									<el-input v-model="item.purchaseModel">
										<template slot="prepend">
											<el-button>海逊仓核对详情:</el-button>
										</template>
									</el-input>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col class="padding" :span="6">
									<el-input v-model="item.purchasePrice">
										<template slot="prepend">
											采购价:
										</template>
									</el-input>
								</el-col>
								<el-col class="padding" :span="6">
									<el-input v-model="item.rebatePrice">
										<template slot="prepend">
											<el-tooltip content="购买后,卖家返回的佣金" placement="top">
												<el-button>返佣:</el-button>
											</el-tooltip>
										</template>
									</el-input>
								</el-col>

								<el-col class="padding" :span="6">
									<el-input v-model="item.actualRefund">
										<template slot="prepend">
											实际退款:
										</template>
									</el-input>
								</el-col>
								<el-col class="padding" :span="6">
									<el-input v-model="item.otherPrice">
										<template slot="prepend">
											退款费用:
										</template>
									</el-input>
								</el-col>
							</el-row>

							<el-row :gutter="20">
								<el-col class="padding" :span="6">
									<span class="leix">类型:</span>
									<el-select v-model="item.purchaseTypeCode" placeholder="请选择" style="width: 77%;"
										class="logistics">
										<el-option v-for="item in selectType" :key="item.value" :label="item.itemTypeName"
											:value="item.itemTypeName"></el-option>
									</el-select>
								</el-col>
								<el-col class="padding" :span="6">
									<span class="leix">物流公司:</span>
									<el-select v-model="item.logisticsCompany" @change="SelectTrack17Logistics2(index)" value-key="id"
										filterable clearable placeholder="请选择" style="width: 63%;" class="logistics">
										<el-option v-for="item in Track17Logistics" :key="item.id" :label="item.nameCn" :value="item">
										</el-option>
									</el-select>
								</el-col>
								<el-col class="padding" :span="12">
									<el-input v-model.trim="item.internalConveyNumber" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
										<template slot="prepend">
											运单号码:
										</template>
									</el-input>
								</el-col>
							</el-row>
							<el-row>
								<el-col class="padding" :span="24">
									<el-input v-model="item.remark">
										<template slot="prepend">
											<el-tooltip content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见" placement="top">
												<el-button>采购备注:</el-button>
											</el-tooltip>
										</template>
									</el-input>
								</el-col>
							</el-row>
						</el-col>
					</el-row>

					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="moreSubmit" :loading="moreLoading">保存</el-button>
						<el-button @click="moreClose">取消</el-button>
					</div>
				</el-dialog>
				<el-dialog width="50%" top="5vh" title="批量同步单据" :visible.sync="asyncVisible" append-to-body>
					<el-row class="border-bottom padding">
						<el-col :span="25">
							<el-row>
								<el-col class="padding checkboxCol" :span="1">
									<el-checkbox v-model="asyncObj.purchaseModelBool"></el-checkbox>
								</el-col>
								<el-col class="padding" :span="23">
									<el-input v-model="asyncObj.purchaseModel">
										<template slot="prepend">
											<el-button>海逊仓核对详情:</el-button>
										</template>
									</el-input>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col class="padding checkboxCol" :span="1">
									<el-checkbox v-model="asyncObj.purchasePriceBool"></el-checkbox>
								</el-col>
								<el-col class="padding" :span="7">
									<el-input v-model="asyncObj.purchasePrice">
										<template slot="prepend">
											采购价:
										</template>
									</el-input>
								</el-col>
								<!-- <el-col class="padding" :span="6">
									<el-input v-model="asyncObj.rebatePrice">
										<template slot="prepend">
											<el-tooltip content="购买后,卖家返回的佣金" placement="top">
												<el-button>返佣:</el-button>
											</el-tooltip>
										</template>
									</el-input>
								</el-col> -->
								<el-col class="padding checkboxCol" :span="1">
										<el-checkbox v-model="asyncObj.actualRefundBool"></el-checkbox>
									</el-col>
								<el-col class="padding" :span="7">
									<el-input v-model="asyncObj.actualRefund">
										<template slot="prepend">
											实际退款:
										</template>
									</el-input>
								</el-col>
								<el-col class="padding checkboxCol" :span="1">
										<el-checkbox v-model="asyncObj.otherPriceBool"></el-checkbox>
									</el-col>
								<el-col class="padding" :span="7">
									<el-input v-model="asyncObj.otherPrice">
										<template slot="prepend">
											退款费用:
										</template>
									</el-input>
								</el-col>
							<!-- </el-row> -->

							<!-- <el-row :gutter="20"> -->
								<!-- <el-col class="padding" :span="6">
									<span class="leix">类型:</span>
									<el-select v-model="asyncObj.purchaseTypeCode" placeholder="请选择" style="width: 77%;"
										class="logistics">
										<el-option v-for="item in selectType" :key="item.value" :label="item.itemTypeName"
											:value="item.itemTypeName"></el-option>
									</el-select>
								</el-col> -->
								<el-col class="padding checkboxCol" :span="1">
									<el-checkbox v-model="asyncObj.logisticsCompanyBool"></el-checkbox>
								</el-col>
								<el-col class="padding" :span="7">
									<span class="leix">物流公司:</span>
									<el-select v-model="asyncObj.logisticsCompany" @change="SelectLogistics3" value-key="id"
										filterable clearable placeholder="请选择" style="width: 63%;" class="logistics">
										<el-option v-for="item in Logistics" :key="item.id" :label="item.logisticsCompanyName"
											:value="item">
										</el-option>
									</el-select>
								</el-col>
								<el-col class="padding checkboxCol" :span="1">
									<el-checkbox v-model="asyncObj.internalConveyNumberBool"></el-checkbox>
								</el-col>
								<el-col class="padding" :span="10">
									<el-input v-model.trim="asyncObj.internalConveyNumber" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
										<template slot="prepend">
											运单号码:
										</template>
									</el-input>
								</el-col>
							</el-row>
							<el-row :gutter="20" v-show="asyncObj.internalConveyNumber">
								<el-col class="padding checkboxCol teshu" :span="1">
									<el-checkbox v-model="asyncObj.estimatedQuantityBool"></el-checkbox>
								</el-col>
								<el-col :span="7" :offset="0">
									<strong>包裹总计包含：</strong>
									<el-input-number v-model="asyncObj.estimatedQuantity" size="small" :min="1" :step="1">
									</el-input-number>
								</el-col>
								<el-col class="padding checkboxCol teshu" :span="1">
									<el-checkbox v-model="asyncObj.useQuantityBool"></el-checkbox>
								</el-col>
								<el-col :span="10" :offset="0">
									<strong>该单据使用商品：</strong>
									<el-input-number v-model="asyncObj.useQuantity" size="small" :min="1" :step="1">
									</el-input-number>
								</el-col>
							</el-row>
							<el-row>
								<el-col class="padding checkboxCol" :span="1">
									<el-checkbox v-model="asyncObj.remarkBool"></el-checkbox>
								</el-col>
								<el-col class="padding" :span="23">
									<el-input v-model="asyncObj.remark">
										<template slot="prepend">
											<el-tooltip content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见" placement="top">
												<el-button>采购备注:</el-button>
											</el-tooltip>
										</template>
									</el-input>
								</el-col>
							</el-row>
						</el-col>
					</el-row>

					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="asyncSubmit">同步</el-button>
						<el-button @click="asyncClose">取消</el-button>
					</div>
				</el-dialog>
			</div>
		</el-tab-pane>
		<el-tab-pane label="采购单据" name="second">
			<el-row class="border-bottom">
				<el-col :span="7" class="fontSize-30 padding">备用金余额：{{ this.balance }}[CNY]</el-col>
				<el-col :span="2" class="margin-top1">
					<el-button type="primary" @click="Reservefund">备用金明细</el-button>
				</el-col>
				<el-col :span="2" class="margin-top1">
					<el-button type="primary" @click="Reservefund1" :disabled="disabled">备用金申请</el-button>
				</el-col>
				<el-col :span="2" class="margin-top1" style="float:right;">
					<el-button type="primary" @click="returnAddress">国内退货地址</el-button>
				</el-col>
			</el-row>
			<el-form :model="ruleForm" ref="ruleForm" label-width="100px" style="overflow: hidden;"
				class="demo-ruleForm border-bottom margin-top2">
				<el-collapse-transition>
					<div v-show="showFilter1">
						<el-row>
							<el-col :span="6">
								<el-form-item label="采购状态" prop="status">
									<el-select v-model="ruleForm.status1" placeholder="请选择" filterable clearable  @change="PurchasingStatus1">
										<el-option v-for="item in OrderList1" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="一单多件" prop="isMultipleDocuments">
									<el-select v-model="ruleForm.isMultipleDocuments" clearable placeholder="请选择">
										<el-option label="是" :value="1"></el-option>
										<el-option label="否" :value="0"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="核对结果" prop="checkResult">
									<el-select v-model="ruleForm.checkResult" clearable placeholder="请选择">
										<el-option label="未核对" :value="0"></el-option>
										<el-option label="核对正确" :value="1"></el-option>
										<el-option label="核对异常" :value="2"></el-option>
										<el-option label="信息部审核通过" :value="3"></el-option>
										<el-option label="未入库" :value="4"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="开始日期" prop="startTimeString">
									<el-date-picker v-model="ruleForm.startTimeString1" align="right" type="datetime" placeholder="选择开始日期"
										format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="结束日期" prop="endTimeString">
									<el-date-picker v-model="ruleForm.endTimeString1" align="right" type="datetime" placeholder="选择结束日期"
										format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="6">
								<el-form-item label="拦截状态" prop="outInterceptStatus">
									<el-radio-group v-model="ruleForm.outInterceptStatus1">
										<el-radio :label="0">未拦截</el-radio>
										<el-radio :label="1">拦截</el-radio>
										<el-radio :label="2">全部</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item label="时间类型" prop="timeType">
									<el-radio-group v-model="ruleForm.timeType1">
										<el-radio :label="1">下单日期</el-radio>
										<el-radio :label="2">提采购需求日期</el-radio>
										<el-radio :label="3">采购日期</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item label="成本" prop="noCost">
									<el-radio-group v-model="ruleForm.noCost">
										<el-radio :label=false>所有</el-radio>
										<el-radio :label=true>无成本</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<el-form-item label="采购标记:" style="width:100%;">
									<el-radio-group v-model="ruleForm.resource1" @change="radiochange1">
										<span v-for="item in this.colorList1" :key="item.id">
											<el-radio :label="item.itemTypeId" style="margin-left:10px;">{{ item.itemTypeName }}</el-radio>
										</span>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="国内运单状态" style="width:100%;">
									<el-radio-group v-model="ruleForm.resource2" @change="radiochange2">
										<el-radio v-for="item in this.colorList2" :key="item.id" :label="item.itemTypeId">{{ item.itemTypeName }}</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
						</el-row>
					</div>
				</el-collapse-transition>
				
				<el-col :span="6">
					<el-form-item prop="searchInput">
						<el-input v-model.trim="ruleForm.searchString1" placeholder="采购单据、海逊仓库核对详情、物流平台、国内运单、采购备注"
						@change="searchForm1"
							style="width: 100%;"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="1"><span style="opacity: 0;">11</span></el-col>
				<el-col :span="10">
					<el-form-item prop="searchString1s">
						<el-input v-model.trim="ruleForm.searchString1s" placeholder="多个订单号搜索以空格隔开"
						@change="searchForm1"
							style="width: 60%;"></el-input>
						<el-button type="primary" @click="searchForm1" style="margin-left:10px;">搜索</el-button>
						<el-button type="primary" @click="resetFprm1">重置</el-button>
						<el-button type="primary" @click="exportOrders">导出系统订单</el-button>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item>
						<el-button type="warning" @click="showFilter1=!showFilter1">{{ showFilter1?'隐藏筛选条件':'显示筛选条件' }}</el-button>
					</el-form-item>
				</el-col>
			</el-form>
			<div class="table-body">
				<div class="table-batch">
					<el-link type="primary" :underline="false" @click="EditSome" :disabled="EditDisabled">
						批量编辑
					</el-link>
					<el-dropdown trigger="click" @command="handleCommand1" style="margin-left:30px;">
						<el-button type="primary" :disabled="colordisabled">
							采购状态标记<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<div v-for="item in this.colorList1" :key="item.id">
								<el-dropdown-item :command="item.itemTypeId">{{
								item.itemTypeName
								}}</el-dropdown-item>
							</div>
						</el-dropdown-menu>
					</el-dropdown>
					<el-dropdown trigger="click" @command="handleCommand2" style="margin-left:30px;">
						<el-button type="primary" :disabled="colordisabled">
							国内单标记<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<div v-for="item in this.colorList2" :key="item.id">
								<el-dropdown-item :command="item.itemTypeId">{{
								item.itemTypeName
								}}</el-dropdown-item>
							</div>
						</el-dropdown-menu>
					</el-dropdown>
					<el-button type="primary" style="margin-left: 30px" v-if="exportBool" @click="exportDetail = true">
						导出采购详情
					</el-button>
					<el-button type="primary" style="margin-left: 30px" @click="dialogVisible = true">
						导入国内运单
					</el-button>
					<el-button type="primary" @click="batchDeletePurchaseMark" style="margin-left: 30px" :disabled="colordisabled">批量删除采购标记</el-button>
				</div>
				<div class="table-list">
					<el-table ref="multipleTable" :data="tableData1" v-loading="loading1" tooltip-effect="dark"
						:header-cell-style="headClass" border style="width: 100%;margin-bottom:50px;"
						@selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="purchaseNumber" width="110" label="采购单据号" align="center">
							<template slot-scope="scope">
								<div>{{ scope.row.purchaseNumber }}</div>
								<el-row type="flex" align="middle">
									<el-tag style="margin-left:5px;" closable @close="handleClose1(scope.row, tag)" v-for="tag in scope.row
									.purchaseMarkItems" :color="tag.itemName" :key="tag.id" effect="dark" size="mini" :type="tag.type">
										{{ tag.itemTypeName }}
									</el-tag>
								</el-row>
								<el-row type="flex" justify="start" v-if="scope.row.checkResult === 2">
									<el-tag size="mini" type="danger" effect="dark">异常</el-tag>
								</el-row>
								<el-row v-if="scope.row.invalidStatus === 0">
									<img :src="pics" alt="" class="picsImg">
								</el-row>
							</template>
						</el-table-column>
						<el-table-column width="280" label="订单号/订单ID">
							<template slot-scope="scope">
								<p v-show="scope.row.orderNumber">订单编码：{{ scope.row.orderNumber }}</p>
								<p>订单ID：{{ scope.row.orderId }}</p>
								<p>订单号：{{ scope.row.amazonOrderId }}</p>
								<p>下单时间：{{ scope.row.purchaseDate }}</p>
								<p>
									订单状态：<span :style="{
										color:
											scope.row.orderStatus ==
											'未发货'
												? 'red'
												: 'black',
									}">{{ scope.row.orderStatus }}</span>
								</p>
								<p>国家：{{ scope.row.countryName }}</p>
								<el-row type="flex" align="middle">
									<el-tag style="margin-left:5px;" closable @close="handleClose2(scope.row, tag)" v-for="tag in scope.row
									.orderPurchaseMarkItems" :color="tag.itemName" :key="tag.id" effect="dark" size="mini" :type="tag.type">
										{{ tag.itemTypeName }}
									</el-tag>
									<el-popover v-if="scope.row.remarks.length != 0" style="display:flex;" placement="top-start"
										trigger="hover">
										<h3>采购备忘录</h3>
										<div v-for="item in scope.row.remarks" :key="item.id">
											<span>{{ item.roleName }}</span>
											<span v-if="item.userName !== null">-</span>
											<span>{{ item.userName }}</span>:
											<span>{{ item.remarkContent }}</span>--
											<span>{{ item.createTime }}</span>
										</div>
										<img class="Memo" slot="reference" src="../../assets/imags/备忘录.png" alt="" />
									</el-popover>
								</el-row>
								<p>
									<el-tooltip class="item" effect="dark" :content="
										'采购要求：' +
											scope.row.purchaseDemand
									" placement="right">
										<i class="el-icon-s-promotion" style="font-size: 17px;cursor: pointer;"></i>
									</el-tooltip>
									<el-tag style="margin-left:5px;" v-if="scope.row.outInterceptStatus == 1" color="red" effect="dark"
										size="mini">
										拦截
									</el-tag>
									<el-popover
										placement="top"
										width="500"
										trigger="click"
										@show="popoverShows(scope.row)"
									>
										<template slot="reference">
											<i class="el-icon-tickets" style="margin-left: 15px;font-size: 17px;cursor: pointer;"></i>
											<!-- <el-tag size="small" style="margin-left: 15px;cursor: pointer;">查看日志</el-tag> -->
											<!-- <el-button type="primary">日志</el-button> -->
										</template>
										<el-timeline>
											<el-timeline-item
												v-for="(activity, index) in activities"
												:key="index"
												:timestamp="activity.createTime"
											>
												{{ activity.operateName }}
											</el-timeline-item>
										</el-timeline>
									</el-popover>
								</p>
								
							</template>
						</el-table-column>
						<el-table-column label="产品信息" width="250">
							<template slot-scope="scope">
								<div class="details" v-for="item in scope.row.productInfos" :key="item.id">
									<div class="details_left">
										<el-popover trigger="hover" placement="right" style="float: left;">
											<img :src="item.imageUrl" class="prduct_img" alt />
											<div class="scope_img" slot="reference">
												<img :src="item.imageUrl" alt />
											</div>
										</el-popover>
									</div>
									<div class="details_right">
										<span>
											<div>
												价格：{{ item.itemAmount }}
												{{ item.itemCurrencyCode }}
											</div>
											<div>SKU：{{ item.sku }}</div>
										</span>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="purchaseStatus" width="90" label="采购状态" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.purchaseStatus === 1" style="color:#f04b22;">待采购</span>
								<span v-if="scope.row.purchaseStatus === 2" style="color:#1677b3;">已采购</span>
								<span v-if="scope.row.purchaseStatus === 3" style="color:#12a182;">已发货</span>
								<span v-if="scope.row.purchaseStatus === 4" style="color:#835e1d;">已签收</span>
								<span v-if="scope.row.purchaseStatus === 5" style="color:#cc163a;">退货</span>
								<span v-if="scope.row.purchaseStatus === 6" style="color:#feba07;">在途</span>
								<span v-if="scope.row.purchaseStatus === 7" style="color:#f97d1c;">揽收</span>
								<span v-if="scope.row.purchaseStatus === 8" style="color:#ffa60f;">疑难</span>
								<span v-if="scope.row.purchaseStatus === 9" style="color:#de1c31;">退签</span>
								<span v-if="scope.row.purchaseStatus === 10" style="color:#b7511d;">派件</span>
								<span v-if="scope.row.purchaseStatus === 11" style="color:#ec4e8a;">退回</span>
								<span v-if="scope.row.purchaseStatus === 12" style="color:#f09c5a;">转投</span>
								<span v-if="scope.row.purchaseStatus === 13" style="color:#619ac3;">待清关</span>
								<span v-if="scope.row.purchaseStatus === 14" style="color:#2775b6;">清关中</span>
								<span v-if="scope.row.purchaseStatus === 15" style="color:#22a2c3;">已清关</span>
								<span v-if="scope.row.purchaseStatus === 16" style="color:#ef498b;">清关异常</span>
								<span v-if="scope.row.purchaseStatus === 17" style="color:#c21f30;">拒签</span>

								<span v-if="scope.row.purchaseStatus === 18" style="color:#c21f30;">清关</span>
								<span v-if="scope.row.purchaseStatus === 101" style="color:#c21f30;">已下单</span>
								<span v-if="scope.row.purchaseStatus === 102" style="color:#c21f30;">待揽收</span>
								<span v-if="scope.row.purchaseStatus === 103" style="color:#c21f30;">已揽收</span>
								<span v-if="scope.row.purchaseStatus === 1001" style="color:#c21f30;">到达派件城市</span>
								<span v-if="scope.row.purchaseStatus === 1002" style="color:#c21f30;">干线</span>
								<span v-if="scope.row.purchaseStatus === 1003" style="color:#c21f30;">转递</span>
								<span v-if="scope.row.purchaseStatus === 501" style="color:#c21f30;">投柜或驿站</span>
								<span v-if="scope.row.purchaseStatus === 301" style="color:#c21f30;">本人签收</span>
								<span v-if="scope.row.purchaseStatus === 302" style="color:#c21f30;">派件异常后签收</span>
								<span v-if="scope.row.purchaseStatus === 303" style="color:#c21f30;">代签</span>
								<span v-if="scope.row.purchaseStatus === 304" style="color:#c21f30;">投柜或站签收</span>
								<span v-if="scope.row.purchaseStatus === 401" style="color:#c21f30;">已销单</span>
								<span v-if="scope.row.purchaseStatus === 201" style="color:#c21f30;">超时未签收</span>
								<span v-if="scope.row.purchaseStatus === 202" style="color:#c21f30;">超时未更新</span>
								<span v-if="scope.row.purchaseStatus === 203" style="color:#c21f30;">拒收</span>
								<span v-if="scope.row.purchaseStatus === 204" style="color:#c21f30;">派件异常</span>
								<span v-if="scope.row.purchaseStatus === 205" style="color:#c21f30;">柜或驿站超时未取</span>
								<span v-if="scope.row.purchaseStatus === 206" style="color:#c21f30;">无法联系</span>
								<span v-if="scope.row.purchaseStatus === 207" style="color:#c21f30;">超区</span>
								<span v-if="scope.row.purchaseStatus === 208" style="color:#c21f30;">滞留</span>
								<span v-if="scope.row.purchaseStatus === 209" style="color:#c21f30;">破损</span>
								<span v-if="scope.row.purchaseStatus === 210" style="color:#c21f30;">销单</span>
							</template>
						</el-table-column>
						<el-table-column prop="purchaseModel" width="110" label="海逊仓库核对详情" align="center"></el-table-column>
						<el-table-column prop="logisticsCompany" width="90" label="物流平台" align="center"></el-table-column>
						<el-table-column label="国内运单" width="200" align="center">
							<template slot-scope="scope">
								<el-popover 
									placement="top" 
									width="800" 
									trigger="hover" 
									:open-delay="1000"
									@show="popoverShow(scope.row)">
									<template>
										<div style="width: 100%;text-align: center;" v-if="popoverStatus">
											{{ popoverText }}
										</div>
										<div style="width: 100%;" v-else>
											<div v-if="popoverInfo.number" style="margin-bottom: 10px;">
												<span>运单号：{{
												popoverInfo.number
												}}</span>
												<span style="margin-left: 10px;">{{
												popoverInfo.track_info.latest_status.status
												}}</span>
											</div>
											<div v-if="popoverInfo.track_info" style="margin-bottom: 10px;">
												<span>时效信息: </span>
												<span style="margin-left: 10px;">订单:{{
												popoverInfo.track_info.time_metrics.days_after_order
												}}天</span>
												<span style="margin-left: 10px;">运输:{{
												popoverInfo.track_info.time_metrics.days_of_transit
												}}天</span>
												<span style="margin-left: 10px;">妥投:{{
												popoverInfo.track_info.time_metrics.days_of_transit_done
												}}天</span>
												<span style="margin-left: 10px;">无更新:{{
												popoverInfo.track_info.time_metrics.days_after_last_update
												}}天</span>
											</div>
											<div v-if="popoverInfo.track_info"
												style="height: 200px;overflow: auto;"
											>
												<div v-for="(item,
														index) in popoverInfo.track_info.tracking.providers[0].events" :key="index" style="margin-bottom: 5px;">
													<div>{{ item.description }}</div>
													<div>{{ timeConversion(item.time_iso) }}</div>
												</div>
											</div>
											
										</div>
									</template>
									<template slot="reference">
										<el-row type="flex" justify="center" align="middle">
											<div style="cursor: pointer;" @click="
												queryDomesticOrderClick(
													scope.row
												)
											">
												<span>{{
												scope.row
												.internalConveyNumber
												}}</span>
											</div>
										</el-row>
									</template>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column prop="totlePrice" width="90" label="采购总计" align="center"></el-table-column>
						<el-table-column prop="shopName" width="110" label="店铺" align="center"></el-table-column>
						<el-table-column width="110" label="采购备注" align="center">
							<template slot-scope="scope">
								<el-popover 
									placement="left" 
									width="600" 
									trigger="click" 
									:open-delay="1000"
									@show="popoverRemarkShow(scope.row)">
									<el-table :data="gridData">
										<el-table-column width="150" property="logisticsBillNo" label="物流单号" align="center"></el-table-column>
										<el-table-column width="100" property="logisticsCompanyName" label="物流公司" align="center"></el-table-column>
										<el-table-column width="350" label="商品信息" align="center">
											<template slot-scope="scope">
												<div class="details" v-for="item in scope.row.sendGoods" :key="item.unit">
													<div>
														<span>
															<div><strong>商品名: </strong>{{ item.goodName }}</div>
															<div><strong>数量: </strong>{{ item.quantity }}</div>
															<div><strong>单位: </strong>{{ item.unit }}</div>
															
														</span>
													</div>
												</div>
											</template>
										</el-table-column>
									</el-table>

									<template slot="reference">
										<el-row type="flex" justify="center" align="middle">
											<div style="cursor: pointer;" >
												<span>
													{{scope.row.remark}}
												</span>
											</div>
										</el-row>
									</template>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column prop="userName" width="110" label="员工" align="center"></el-table-column>
						<el-table-column prop="createTime" width="110" label="采购时间" align="center"></el-table-column>
						<el-table-column label="操作" fixed="right" class="edit" align="center" width="120">
							<template slot-scope="scope">
								<el-button type="primary" @click="edit1(scope.row)">采购编辑</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<div class="page">
				<el-pagination style="margin-right:200px;" @size-change="handleSizeChange1"
					@current-change="handleCurrentChange1" :current-page="currentPage1" :page-sizes="[20, 50, 100, 200, 400, 500, 1000]"
					:page-size="pagesize1" layout="total, sizes, prev, pager, next, jumper" :total="total1"></el-pagination>
			</div>

			<el-dialog title="备用金明细" :visible.sync="dialogTableVisible" width="55%">
				<el-table :data="pettyCash" :header-cell-style="headClass" border tooltip-effect="dark" style="width: 100%">
					<el-table-column label="单据号">
						<template slot-scope="scope">
							<span v-if="scope.row.firstStatus == 1">{{
							scope.row.receiptNumber
							}}</span>
							<span v-if="scope.row.firstStatus == 2" style="color:red;">{{ scope.row.receiptNumber }}</span>
						</template>
					</el-table-column>
					<el-table-column label="单据类型">
						<template slot-scope="scope">
							<span v-if="scope.row.firstStatus == 1">{{
							scope.row.receiptType
							}}</span>
							<span v-if="scope.row.firstStatus == 2" style="color:red;">{{ scope.row.receiptType }}</span>
						</template>
					</el-table-column>
					<el-table-column label="单据金额">
						<template slot-scope="scope">
							<span v-if="scope.row.firstStatus == 1">{{
							scope.row.receiptMoney
							}}</span>
							<span v-if="scope.row.firstStatus == 2" style="color:red;">{{ scope.row.receiptMoney }}</span>
						</template>
					</el-table-column>
					<el-table-column label="余额">
						<template slot-scope="scope">
							<span v-if="scope.row.firstStatus == 1">{{
							scope.row.receiptBalance
							}}</span>
							<span v-if="scope.row.firstStatus == 2" style="color:red;">{{ scope.row.receiptBalance }}</span>
						</template>
					</el-table-column>
					<el-table-column label="时间">
						<template slot-scope="scope">
							<span v-if="scope.row.firstStatus == 1">{{
							scope.row.createTime
							}}</span>
							<span v-if="scope.row.firstStatus == 2" style="color:red;">{{ scope.row.createTime }}</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="page1">
					<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
						:current-page="currentPage2" :page-sizes="[20, 50, 100, 200]" :page-size="pagesize2"
						layout="total, sizes, prev, pager, next, jumper" :total="total2"></el-pagination>
				</div>
			</el-dialog>

			<el-dialog title="备用金申请" :visible.sync="PettyCashApplication" width="25%" style="margin-top:20px;">
				<el-input placeholder="请输入内容" v-model="receiptMoney" style="margin-top:10px;">
					<template slot="prepend">
						金额：
					</template>
				</el-input>

				<el-input placeholder="请输入内容" v-model="remark" style="margin-top:10px;">
					<template slot="prepend">
						备注：
					</template>
				</el-input>

				<div slot="footer" class="dialog-footer">
					<el-button @click="PettyCashApplication = false">取 消</el-button>
					<el-button type="primary" @click="pettyCashSubmit">提 交</el-button>
				</div>
			</el-dialog>

			<el-dialog title="收货地址" :visible.sync="Shipping" width="40%">
				<el-link type="primary" icon="el-icon-circle-plus-outline" @click="innerVisible = true">
					新增收货地址
				</el-link>
				<div style="margin-top:10px;">
					<el-table :data="AddressData" style="width: 100%">
						<el-table-column label width="100">
							<template slot-scope="scope">
								<el-radio-group v-model="radioId" @change="radio">
									<el-radio :label="scope.row.id">&nbsp;</el-radio>
								</el-radio-group>
							</template>
						</el-table-column>
						<el-table-column prop="remarks" label="备注" align="center"></el-table-column>
						<el-table-column prop="recipientName" label="收件人" align="center"></el-table-column>
						<el-table-column prop="recipientTelephone" label="收货人电话" align="center"></el-table-column>
						<el-table-column prop="receivingAddress" label="收货地址" align="center"></el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<el-link type="primary" @click="EditAddressShow(scope.row)" icon="el-icon-edit" :underline="false">
									编辑
								</el-link>
								<el-link type="danger" @click="DelAddress(scope.row)" icon="el-icon-delete" style="margin-left:10px;"
									:underline="false">
									删除
								</el-link>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<el-dialog width="30%" title="新增收货地址" :visible.sync="innerVisible" append-to-body top="20vh">
					<div>
						<el-form ref="form" label-width="100px">
							<el-form-item label="收货地址">
								<el-input v-model="receivingAddress" style="width:400px;"></el-input>
							</el-form-item>
							<el-form-item label="收件人">
								<el-input v-model="recipientName" style="width:400px;"></el-input>
							</el-form-item>
							<el-form-item label="收件人电话">
								<el-input v-model="recipientTelephone" style="width:400px;"></el-input>
							</el-form-item>
							<el-form-item label="备注">
								<el-input v-model="remarks" style="width:400px;"></el-input>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="innerVisible = false">取消</el-button>
						<el-button type="primary" @click="AddAddress">添加</el-button>
					</span>
				</el-dialog>

				<el-dialog width="30%" title="编辑收货地址" :visible.sync="innerVisible1" append-to-body top="20vh">
					<div>
						<el-form ref="form" label-width="100px">
							<el-form-item label="收货地址">
								<el-input v-model="receivingAddress1" style="width:400px;"></el-input>
							</el-form-item>
							<el-form-item label="收件人">
								<el-input v-model="recipientName1" style="width:400px;"></el-input>
							</el-form-item>
							<el-form-item label="收件人电话">
								<el-input v-model="recipientTelephone1" style="width:400px;"></el-input>
							</el-form-item>
							<el-form-item label="备注">
								<el-input v-model="remarks1" style="width:400px;"></el-input>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="innerVisible1 = false">取消</el-button>
						<el-button type="primary" @click="EditAddress">修改</el-button>
					</span>
				</el-dialog>

				<span slot="footer" class="dialog-footer">
					<el-button @click="defaultAddress">设为默认地址</el-button>
					<el-button @click="Shipping = false">取消</el-button>
					<el-button type="primary" @click="Shipping = false">确定</el-button>
				</span>
			</el-dialog>

			<el-dialog title="批量编辑采购单" custom-class="morePurchase" :visible.sync="batchEditor" width="54%" top="5vh">
				<div class="PurchaseOrder" :class="index == editAllPurchase.length-1 ? 'last' : ''" v-for="(item, index) in editAllPurchase" :key="index+'ee'">
					<el-row>
						<el-col class="padding" :span="index == 0 ? 20 : 24">
							<el-input
								v-model="item.purchaseModel" :disabled="item.isDisabled"
							>
								<template slot="prepend">
									<el-tooltip
										:content="item.isContens"
										placement="top"
									>
										<el-button>海逊仓库核对详情:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="4" v-if="index === 0">
							<el-button type="primary" @click="moreSet(2)" style="margin-left: 50px;">同步单据</el-button>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col class="padding" :span="6">
							<el-input v-model="item.purchasePrice">
								<template slot="prepend">采购价:</template>
							</el-input>
						</el-col>

						<el-col class="padding" :span="6">
							<el-input v-model="item.rebatePrice">
								<template slot="prepend">返佣:</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="6">
							<el-input v-model="item.actualRefund">
								<template slot="prepend">实际退款:</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="6">
							<el-input v-model="item.otherPrice">
								<template slot="prepend">退款费用:</template>
							</el-input>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col class="padding" :span="6">
							<span class="leix">类型:</span>
							<el-select v-model="item.purchaseTypeCode" placeholder="请选择" style="width:77%;" class="logistics">
								<el-option v-for="ele in selectType" :key="ele.itemTypeId" :label="ele.itemTypeName" :value="ele.itemTypeName"></el-option>
							</el-select>
						</el-col>
						<el-col class="padding" :span="6">
							<span class="leix">物流公司:</span>
							<el-tooltip
								class="item"
								effect="dark"
								:content="item.isContent"
								placement="top-start"
							>
								<el-select v-model="item.logisticsCompany" value-key="id" clearable filterable placeholder="请选择" style="width: 62%;" class="logistics"
									@change="SelectTrack17Logistics3(index)" :disabled="item.isDisabled">
									<el-option v-for="ele in Track17Logistics" :key="ele.id" :label="ele.nameCn" :value="ele">
									</el-option>
								</el-select>
							</el-tooltip>
						</el-col>

						<el-col class="padding" :span="12">
							<el-tooltip
								class="item"
								effect="dark"
								:content="item.isContent"
								placement="top-start"
							>
								<el-input v-model.trim="item.internalConveyNumber" @input="getQuantity(index)" :disabled="item.isDisabled">
									<template slot="prepend">运单号码:</template>
								</el-input>
							</el-tooltip>
						</el-col>
					</el-row>

					<el-row :gutter="20" v-show="item.internalConveyNumber">
						<el-col :span="7" :offset="0">
							<strong>包裹总计包含：</strong>
							<el-input-number v-model="item.estimatedQuantity" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
						<el-col :span="12" :offset="0">
							<strong>该单据使用商品：</strong>
							<el-input-number v-model="item.useQuantity" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
					</el-row>

					<el-row>
						<el-col class="padding" :span="24">
							<el-input v-model="item.remark">
								<template slot="prepend">采购备注:</template>
							</el-input>
						</el-col>
					</el-row>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchEditor = false">取消</el-button>
					<el-button type="primary" :loading="batchLoading" @click="AddEdit">提交</el-button>
				</span>
			</el-dialog>

			<PurchasingDocuments ref="PurchasingDocuments" @refresh="refresh" />

			<el-dialog title="导出采购详情" :visible.sync="exportDetail" width="28%">
				<el-row v-for="(item, index) in remarkList" :key="index" style="margin-bottom: 18px;">
					<el-col :span="4" style="text-align: center;">采购备注</el-col>
					<el-col :span="15" style="margin-right: 10px;">
						<el-input v-model="remarkList[index]"></el-input>
					</el-col>
					<el-col :span="1"></el-col>
					<el-col :span="4">
						<el-button type="success" size="small" @click="addRemark" v-if="index === 0">添加</el-button>
						<el-button type="danger" size="small" @click="removeRemark(index)" v-else>删除</el-button>
					</el-col>
				</el-row>
				<div slot="footer" class="dialog-footer">
					<el-button @click="closeRemark">取 消</el-button>
					<el-button type="primary" @click="submitRemark">提 交</el-button>
				</div>
			</el-dialog>

			<el-dialog
				title="导入国内运单"
				:visible.sync="dialogVisible"
				width="30%"
				@close="handleUploadExcelDialogClose"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				destroy-on-close
			>
				<el-row type="flex" align="middle">
					<upload-excel-component :on-success="handleUploadExcelSuccess"/>
					<el-button style="margin-left: 10px;" @click="downloadTemplate">下载模板</el-button>
				</el-row>
				<div class="file-box">
					<div v-for="(item, index) in listFile" :key="index">{{ `${ index + 1 }. ${ item.fileName }` }}</div>
				</div>
				<div class="file-box" v-show="errorList">
					<span><span style="color: red">导入异常备注：</span>{{ errorList }}</span>
				</div>
				<div slot="footer">
					<el-button
						size="small"
						@click="handleUploadExcelSubmit"
						:loading="btnLoading"
					>确定导入
					</el-button>
				</div>
			</el-dialog>
		</el-tab-pane>
		<el-tab-pane label="1688订单-多物流信息" name="third">
			<div>
				<el-form :model="ruleForm" ref="ruleForm" label-width="100px" style="overflow: hidden;"
					class="demo-ruleForm border-bottom margin-top2">

					<el-col :span="5">
						<el-form-item label="开始日期" prop="startTime4">
							<el-date-picker v-model="ruleForm.startTime" @change="startTime4" align="right" type="date"
							placeholder="选择开始日期" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="结束日期" prop="endTime4">
							<el-date-picker v-model="ruleForm.endTime" @change="endTime4" align="right" type="date"
							placeholder="选择结束日期" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="searchInput">
							<el-input v-model="ruleForm.searchStr" placeholder="1688订单id" @change="searchForm4" style="width: 70%;"></el-input>
							<el-button type="primary" @click="search4" style="margin-left:10px;">搜索</el-button>
							<el-button type="primary" @click="resetFprm4">重置</el-button>
						</el-form-item>
					</el-col>
				</el-form>


				<div class="table-body">
				<div class="table-batch">
					<el-popover
					placement="left"
					trigger="click">
						<div>
							<el-date-picker
							v-model="exportTime"
							type="datetimerange"
							size="small"
							value-format="yyyy-MM-dd HH:mm:ss"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
							<el-button type="primary" @click="handleExport" style="float: right; margin-left: 10px;">
							确定
							</el-button>
						</div>
						<el-button type="primary" slot="reference">
							导出1688多物流信息
						</el-button>
					</el-popover>
				
				</div>
				<div class="table-list">
					<el-table width="100%" :data="tableData4" border :header-cell-style="{ textAlign: 'center' }" v-loading="loading" @selection-change="handleSelectionChange4">
						<!-- <el-table-column type="selection" width="55" align="center" ></el-table-column> -->
						<el-table-column width="80" prop="id" label="id" align="center" />
						<el-table-column width="180" prop="alibabaOrderId" label="1688订单id" align="center"></el-table-column>
						<el-table-column label="1688订单多物流信息" align="center">
							<el-table-column label="物流编号" width="200">
								<template slot-scope="scope">
									<div class="details1" v-for="(item, index) in scope.row.alibabaLogisticsDtos" :key="index">
										<el-popover 
											placement="top" 
											width="800" 
											trigger="click" 
											:open-delay="1000"
											@show="popoverShowAlibabaTrack(item.logisticsId, scope.row.alibabaOrderId, scope.row.companyId)">

											<template>
												<div style="width: 100%;text-align: center;" v-if="popoverStatus">
													{{ popoverText }}
												</div>
												<div style="width: 100%;" v-else>
													<div style="margin-bottom: 10px;">
															<span>运单号：{{ popoverInfo.logisticsBillNo }} 
															</span>
													</div>
													<div style="height: 200px;overflow: auto;">
														<div v-for="(item, index) in popoverInfo.logisticsSteps" :key="index" style="margin-bottom: 5px;">
															<div>{{ item.remark }}</div>
															<div>{{ item.acceptTime }}</div>
														</div>
													</div>
												</div>
											</template>

											<template slot="reference">
												<div style="width: 100%; 
												text-align: center;
												cursor: pointer;">
													{{ item.logisticsBillNo }}
												</div>
											</template>
										</el-popover>	
										
									</div>
								</template>	
							</el-table-column>
							<el-table-column label="物流公司" width="200">
								<template slot-scope="scope">
									<div class="details" v-for="(item, index) in scope.row.alibabaLogisticsDtos" :key="index">
										<div style="width: 100%; text-align: center;">
											<div v-if="item.logisticsCompanyName !== null">
												{{ item.logisticsCompanyName }}
											</div>
										</div>
									</div>
								</template>	
							</el-table-column>
							<el-table-column label="商品数量" width="80">
								<template slot-scope="scope">
									<div class="details" v-for="(item, index) in scope.row.alibabaLogisticsDtos" :key="index">
										<div style="width: 100%; text-align: center;">
											<div v-if="item.quantity !== null">
												{{ item.quantity }}
											</div>
										</div>
									</div>
								</template>	
							</el-table-column>
							
							<el-table-column label="备注" width="180">
								<template slot-scope="scope">
									<div class="details" v-for="(item, index) in scope.row.alibabaLogisticsDtos" :key="index">
										<div style="width: 100%; text-align: center;">
											<div v-if="item.remarks !== null">
												{{ item.remarks }}
											</div>
										</div>
									</div>
								</template>	
							</el-table-column>
						</el-table-column>

						<el-table-column label="补充物流信息" align="center">
							<el-table-column label="物流编号" width="200">
								<template slot-scope="scope">
									<div class="details1" v-for="(item, index) in scope.row.additionalLogisticsInfos" :key="index">
										<el-popover 
											placement="top" 
											width="800" 
											trigger="click" 
											:open-delay="1000"
											@show="popoverShowAdditional(item)">

											<template>
												<div style="width: 100%;text-align: center;" v-if="popoverStatus">
													{{ popoverText }}
												</div>
												<div style="width: 100%;" v-else>
													<div v-if="popoverInfo.number" style="margin-bottom: 10px;">
														<span>运单号：{{ popoverInfo.number }} 
														</span>
														<span style="margin-left: 10px;">{{
															popoverInfo.track_info.latest_status.status
														}}</span>
													</div>
													<div v-if="popoverInfo.track_info" style="margin-bottom: 10px;">
														<span>时效信息: </span>
														<span style="margin-left: 10px;">订单:{{
														popoverInfo.track_info.time_metrics.days_after_order
														}}天</span>
														<span style="margin-left: 10px;">运输:{{
														popoverInfo.track_info.time_metrics.days_of_transit
														}}天</span>
														<span style="margin-left: 10px;">妥投:{{
														popoverInfo.track_info.time_metrics.days_of_transit_done
														}}天</span>
														<span style="margin-left: 10px;">无更新:{{
														popoverInfo.track_info.time_metrics.days_after_last_update
														}}天</span>
													</div>
													<div v-if="popoverInfo.track_info" style="height: 200px;overflow: auto;"
													>
														<div v-for="(item,
																index) in popoverInfo.track_info.tracking.providers[0].events" :key="index" style="margin-bottom: 5px;">
															<div >{{ item.description }}</div>
															<div>{{ timeConversion(item.time_iso) }}</div>
														</div>
													</div>
												</div>
											</template>

											<template slot="reference">
												<div style="width: 100%; 
												text-align: center;
												cursor: pointer;">
													{{ item.conveyNumber }}
												</div>
											</template>
										</el-popover>	
										
									</div>
								</template>	
							</el-table-column>
							<el-table-column label="物流公司" width="200">
								<template slot-scope="scope">
									<div class="details" v-for="(item, index) in scope.row.additionalLogisticsInfos" :key="index">
										<div style="width: 100%; text-align: center;">
											<div v-if="item.logisticsCompany !== null">
												{{ item.logisticsCompany }}
											</div>
										</div>
									</div>
								</template>	
							</el-table-column>
							<el-table-column label="预计商品数量" width="80">
								<template slot-scope="scope">
									<div class="details" v-for="(item, index) in scope.row.additionalLogisticsInfos" :key="index">
										<div style="width: 100%; text-align: center;">
											<div v-if="item.estimatedQuantity !== null">
												{{ item.estimatedQuantity }}
											</div>
										</div>
									</div>
								</template>	
							</el-table-column>
							<el-table-column label="到货商品数量" width="80">
								<template slot-scope="scope">
									<div class="details" v-for="(item, index) in scope.row.additionalLogisticsInfos" :key="index">
										<div style="width: 100%; text-align: center;">
											<div v-if="item.receivedQuantity !== null">
												{{ item.receivedQuantity }}
											</div>
										</div>
									</div>
								</template>	
							</el-table-column>
						</el-table-column>

						<el-table-column width="200" prop="createTime" label="创建时间" align="center"></el-table-column>
						<el-table-column width="200" prop="updateTime" label="修改时间" align="center"></el-table-column>

						<el-table-column label="操作" align="center" width="150" fixed="right">
							<template slot-scope="scope">
								<el-button
									type="primary"
									@click="edit4(scope.row.alibabaOrderId)"
									>补充物流信息</el-button
								>
							</template>
						</el-table-column>
					
					</el-table>
				</div>

				<AlibabaLogisticsEdit ref="AlibabaLogisticsEdit" @refresh="refresh" />
				</div>


				<div class="page">
					<el-pagination style="margin-right:200px;" @size-change="handleSizeChange4"
						@current-change="handleCurrentChange4" :current-page="currentPage4" :page-sizes="[20, 50, 100, 200, 500]"
						:page-size="pagesize4" layout="total, sizes, prev, pager, next, jumper" :total="total4"></el-pagination>
				</div>
			</div>
			
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import Orderpurchaseedit from './Orderpurchaseedit/Orderpurchaseedit'
import PurchasingDocuments from './Orderpurchaseedit/PurchasingDocuments'
import AlibabaLogisticsEdit from './Orderpurchaseedit/AlibabaLogisticsEdit'
import { ajaxPost, Baseurl } from '../../api/api/api'
import axios from 'axios'
export default {
	name: 'Orderpurchase',
	components: {
		Orderpurchaseedit,
		PurchasingDocuments,
		AlibabaLogisticsEdit,
		UploadExcelComponent
		
	},
	data() {
		var pics = require('../../assets/imags/pics.png')
		return {
			exportTime: [],
			gridData: [],
			pics: pics,
			activeName: 'first',
			loading: '',
			loading1: '',
			arrList: '',
			headClass: this.common.headClass,
			disabled: false,
			EditDisabled: true,
			radioId: '',
			balance: '',
			str: '',
			strSeller: '',
			pettyCash: [],
			multipleSelection: [],
			currentPage: 1,
			currentPage1: 1,
			currentPage2: 1,
			currentPage3: 1,
			currentPage4: 1,
			pagesize: 20,
			pagesize1: 20,
			pagesize2: 20,
			pagesize3: 20,
			pagesize4: 20,
			size: 20,
			size1: 20,
			size2: 20,
			size3: 20,
			size4: 20,
			total: 0,
			total1: 0,
			total2: 0,
			total3: 0,
			total4: 0,
			dialogTableVisible: false,
			Shipping: false,
			innerVisible: false,
			innerVisible1: false,
			PettyCashApplication: false,
			batchEditor: false,
			BranchOfficeList: [],
			ShopList: '',
			receiptMoney: '',
			remark: '',
			OrderList1: [
				{
					value: '1',
					label: '待采购',
				},
				{
					value: '2',
					label: '已采购',
				},
				{
					value: '3',
					label: '已发货',
				},
				{
					value: '4',
					label: '已签收',
				},
				{
					value: '5',
					label: '退货',
				},
				{
					value: '6',
					label: '在途',
				},
				{
					value: '7',
					label: '揽收',
				},
				{
					value: '8',
					label: '疑难',
				},
				{
					value: '9',
					label: '退签',
				},
				{
					value: '10',
					label: '派件',
				},
				{
					value: '11',
					label: '退回',
				},
				{
					value: '12',
					label: '转投',
				},
				{
					value: '13',
					label: '待清关',
				},
				{
					value: '14',
					label: '清关中',
				},
				{
					value: '15',
					label: '已清关',
				},
				{
					value: '16',
					label: '清关异常',
				},
				{
					value: '17',
					label: '拒签',
				},
				{
					value: '18',
					label: '清关',
				},
				{
					value: '101',
					label: '已下单',
				},
				{
					value: '102',
					label: '待揽收',
				},
				{
					value: '103',
					label: '已揽收',
				},
				{
					value: '1001',
					label: '到达派件城市',
				},
				{
					value: '1002',
					label: '干线',
				},
				{
					value: '1003',
					label: '转递',
				},
				{
					value: '501',
					label: '投柜或驿站',
				},
				{
					value: '301',
					label: '本人签收',
				},
				{
					value: '302',
					label: '派件异常后签收',
				},
				{
					value: '303',
					label: '代签',
				},
				{
					value: '304',
					label: '投柜或站签收',
				},
				{
					value: '401',
					label: '已销单',
				},
				{
					value: '201',
					label: '超时未签收',
				},
				{
					value: '202',
					label: '超时未更新',
				},
				{
					value: '203',
					label: '拒收',
				},
				{
					value: '204',
					label: '派件异常',
				},
				{
					value: '205',
					label: '柜或驿站超时未取',
				},
				{
					value: '206',
					label: '无法联系',
				},
				{
					value: '207',
					label: '超区',
				},
				{
					value: '208',
					label: '滞留',
				},
				{
					value: '209',
					label: '破损',
				},
				{
					value: '210',
					label: '销单',
				},

			],
			OrderList: [
				{
					value: '0',
					label: '未采购',
				},
				{
					value: '1',
					label: '已采购',
				},
			],
			PaymentList: [
				{
					value: '0',
					label: '一次采购',
				},
				{
					value: '1',
					label: '二次采购',
				},
			],
			ruleForm: {
				shopName: null, //选择店铺
				countryMark: null, //选择国家
				startTimeString: null, //开始时间
				endTimeString: null, //结束时间
				status: '未采购', //采购状态
				type: null, //采购类型
				searchString: null, //全字段搜索
				buttonStatus: 1, //提交状态
				outInterceptStatus: 0, //拦截状态
				timeType: 2, //时间类型

				startTimeString1: null, //开始时间
				endTimeString1: null, //结束时间
				status1: null, //采购状态
				type1: null, //采购类型
				searchString1: null, //全字段搜索
				outInterceptStatus1: 2, //拦截状态
				timeType1: 3, //时间类型
				noCost: false,

				// 1688-物流信息页面搜索条件
				startTime: '',
				endTime: '',
				searchStr: '',

				resource1: '',
				resource2: '',
			},
			SubList: [
				{ label: '是', value: 0 },
				{ label: '否', value: 1 },
			],
			receivingAddress: '',
			recipientName: '',
			recipientTelephone: '',
			remarks: '',

			receivingAddress1: '',
			recipientName1: '',
			recipientTelephone1: '',
			remarks1: '',

			AddressId: '',

			tableData: [],
			tableData1: [],
			tableData4: [],
			AddressData: [],
			BatchEditPurchaseOrder: {
				purchasingPrice: '',
				commission: '',
				actualRefund: '',
				type: '',
				refundFee: '',
				LogisticsCompany: '',
				TrackingNumber: '',
				ProcurementNote: '',
				companyCode: '',
				purchaseModel: ''
			},
			editAllPurchase: [],
			selectType: [],
			ids: [],
			deliveryAddress: false,
			warehouseAddress: [],
			colorList1: [],
			colorList3: [],
			colorList4: {},
			colordisabled: true,
			purchaseMark: '',
			orderPurchaseMark: '',

			popoverText: '查询中...',
			popoverStatus: true,
			popoverInfo: null,
			popoverDomesticOrderStatus: {
				0: '在途',
				1: '揽收',
				2: '疑难',
				3: '签收',
				4: '退签',
				5: '派件',
				6: '退回',
				7: '转投',
				10: '待清关',
				11: '清关中',
				12: '已清关',
				13: '清关异常',
				14: '拒签',
			},
			Logistics: [],
			Track17Logistics: [],
			domesticvalue: '',
			colorList2: [],
			exportBool: false,
			exportDetail: false,
			remarkList: [''],
			allPurchase: true,
			showTuiBool: false,
			moreTableData: [],
			moreLoading: false,
			purchaseMoreVisible: false,
			billsMoreVisible: false,
			demandList: [],
			AddinnerVisible: false,
			morePurchaseFrom: {
				purchasePrice: '',
				rebatePrice: '',
				actualRefund: '',
				otherPrice: '',
				purchaseTypeCode: '',
				logisticsCompany: '',
				companyCode: '',
				internalConveyNumber: '',
				remark: ''
			},
			isLoading: false,
			activities: [],
			collapseval: '1',
			listCountry: [],
			partition: '',
			asyncObj: {},
			asyncVisible: false,
			batchLoading: false,
			asyncType: 1,
			dialogVisible: false,
			returnList: [],
			listFile: [],
			errorList: '',
			btnLoading: false,
			showFilter: true,
			showFilter1: true,

			// 批量匹配库存
			inventoryList: [],
			inventoryList1: [],
			ReturninventoryList: [],
			ReturninventoryList1: [],
			ReturninventoryLists: [],
			ReturninventoryLists1: [],
			ReturninventoryList1s: [],
			btnloading: false,
			isContent: '',
			innerVisibles: false,
			searchString: '',
			tableLoading1: true,
			btndisabled: false,
			submitdisabled: true,
			platforms:[],
		}
	},
	mounted() { 
		this.$nextTick(() => {
			this.syncRowHeights()
		})
	},
	updated() {
		// this.$nextTick(() => {
		// 	this.syncRowHeights()
		// })
	},
	created() {
		let API = Baseurl + 'purchaseController/selectItemList'
		ajaxPost(API, {itemCode:"HYXUN0000014"}).then((res) => {
			this.platforms=res.data.data;
		})
		this.str = JSON.parse(localStorage.getItem('role'))
		this.strSeller = JSON.parse(localStorage.getItem('sellerInfo'))
		this.search()
		this.search1()
		this.search4()
		this.SelectTheStore()
		this.orderTag()
		this.orderTagStatus()
		this.orderTagStatus1()
		this.LogisticsAjax()
		this.Track17LogisticsAjax()
		this.domesticTag()
		this.exportShow()
		this.TypeList()
		this.getListCountry()
	},
	watch: {
		AddinnerVisible(val) {
			if (!val) {
				this.morePurchaseFrom = {
					purchasePrice: '',
					rebatePrice: '',
					actualRefund: '',
					otherPrice: '',
					purchaseTypeCode: '',
					logisticsCompany: '',
					internalConveyNumber: '',
					remark: ''
				}
			}
		}
	},
	methods: {
		exportOrders(){
			console.log(this.ruleForm.searchString1s);
			if (!this.ruleForm.searchString1s || !this.ruleForm.searchString1s.length) {
				this.$message.error("请输入导出订单号！")
				return
			}
			axios.post("https://hx17.hyxun.top/api/export", { 
				list: this.ruleForm.searchString1s.split(' '),
				purchaseRoleId: this.str.rid,
			}, {
				// 2. 关键！告诉 axios 期望的响应类型是 'blob' (二进制文件)
				responseType: 'blob' 
			}).then((response) => {
				// 3. 从响应头中获取 MIME 类型
				const contentType = response.headers['content-type'];
				
				// 4. 创建一个 Blob 对象
				const blob = new Blob([response.data], { type: contentType });

				// 5. 使用 URL.createObjectURL 为 Blob 创建一个临时的 URL
				const url = window.URL.createObjectURL(blob);

				// 6. 创建一个隐藏的 <a> 标签
				const link = document.createElement('a');
				link.href = url;

				// 7. 从响应头中解析文件名 (这是更健壮的做法)
				// 您的后端设置了 download_name="result.xlsx"，会体现在 Content-Disposition 头中
				let filename = '订单.xlsx'; // 默认文件名
				const disposition = response.headers['content-disposition'];
				if (disposition) {
					const filenameMatch = disposition.match(/filename="?(.+?)"?$/);
					if (filenameMatch && filenameMatch.length === 2) {
						filename = filenameMatch[1];
					}
				}
				link.setAttribute('download', filename);

				// 8. 将 <a> 标签添加到页面中 (使其可点击)
				document.body.appendChild(link);

				// 9. 模拟点击
				link.click();

				// 10. 清理：移除 <a> 标签并释放 URL
				link.remove();
				window.URL.revokeObjectURL(url);
			})
		},
		syncRowHeights() {
			// 假设每行对应的 productInfos 和 inventoryInfo 数量一致
			const details = document.querySelectorAll('.details')
			details.forEach((el) => {
				const classNames = Array.from(el.classList)
				const targetClass = classNames.find((cls) => cls.startsWith('product-row-'))
					if (targetClass) {
					const inventoryEl = document.querySelector('.' + targetClass.replace('product-row-', 'inventory-row-'))
					if (inventoryEl) {
						const maxHeight = Math.max(el.offsetHeight, inventoryEl.offsetHeight)
						el.style.height = maxHeight + 'px'
						inventoryEl.style.height = maxHeight + 'px'
					}
				}
			})
		},
		// 时间转换
		timeConversion(item){
			const date = new Date(item);
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const day = date.getDate().toString().padStart(2, '0');
			const hour = date.getHours().toString().padStart(2, '0');
			const minute = date.getMinutes().toString().padStart(2, '0');
			const seconds = date.getSeconds().toString().padStart(2, '0');
			const formattedTime = `${year}/${month}/${day} ${hour}:${minute}:${seconds}`
			return formattedTime
		},
		batchDeletePurchaseMark () {
			this.$confirm('此操作将删除选中数据采购标记, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				console.log("删除采购标记");
				const ids = this.multipleSelection.map(item => item.id)
				console.log(this.multipleSelection.map(item => item.id));
				ajaxPost(Baseurl + 'purchaseController/batchDeletePurchaseMark', { ids }).then((res) => {
					if (res.data.code == 200) {
						this.search1()
					} else {
						this.$message({
						type: 'error',
						message: res.data.data
						});
					}
				})
			}).catch(() => {
				this.$message({
				type: 'info',
				message: '已取消删除'
				});
			});
		},
		handleExport() {
			console.log(this.exportTime);
			if (!this.exportTime || !this.exportTime.length) {
				this.$message.error("请选择导出时间段！")
				return
			}
			window.open(`${Baseurl}alibabaLogisticsInfoController/alibabaLogisticsInfoExport?start=${this.exportTime[0]}&end=${this.exportTime[1]}&companyId=${this.str.company_id}`, 'target');
		},
		async popoverRemarkShow(item) {
			this.popoverText = '查询中...'
			try {
				const data = await this.queryAlibabaLogisticsInfo(item)
				this.gridData = data
			} catch (error) {
				this.popoverText = error || '查询失败'
			}
		},
		queryAlibabaLogisticsInfo(item) {
			const API = Baseurl + 'alibabaLogisticsController/getLogisticsInfos'
			const paramsDate = {
				remark: item.remark,
				companyId: item.companyId,
			}
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
						// console.log(data)
					} else {
						reject(data)
					}
				})
			})
		},
		calculateMax(row) {
			return row.actualCount / this.multipleSelection.length;
		},
		selectable(row) {
			// 库存不足以批量匹配时禁用
			if (row.actualCount < this.multipleSelection.length) {
				return false;//禁用状态
			} else {
				return true;//非禁用状态
			}
		},
		batchMatchInventory() {
			// console.log('批量匹配库存')
			if (this.allPurchase) {
				this.$message.error("批量采购只能用在未采购并且未提交的订单使用！")
				return
			}
			this.innerVisibles = true
			this.searchString = ''
			this.matchingAjax()
		},
		save() {
			var obj = {
				loginRoleId: this.str.rid,
				type: 1,
				inventorys: this.ReturninventoryLists,
				inventorys1: this.ReturninventoryLists1,
			}
			ajaxPost(
				Baseurl + 'inventoryController/insertInventoryCopy',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					// this.innerVisibles = false
					this.inventoryAjax()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		matchingAjaxSearch() {
			this.currentPage3 = 1
			this.matchingAjax()
		},
		matchingAjax() {
			this.tableLoading1 = true
			var obj = {
				roleId: this.str.rid,
				companyId: this.str.company_id,
				searchString: this.searchString,
				page: this.currentPage3,
				size: this.size3,
			}
			ajaxPost(Baseurl + 'inventoryController/getAllInventory', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.inventoryList = res.data.data.list
						this.total3 = res.data.data.total
					}
					this.inventorySkuList = []
					this.tableLoading1 = false
				}
			)
		},
		handleSelectionChange1(val) {
			console.log(val);
			this.ReturninventoryLists = val
		},
		handleSelectionChange4(list) {
			this.idList = list.map(x => x.id)
		},
		handleSizeChange3(val) {
			this.size3 = val
			this.matchingAjax()
			const tableWrapper = this.$refs.table.$el.querySelector('.el-table__body-wrapper');
			if (tableWrapper) {
				tableWrapper.scrollTop = 0;
			}
		},
		handleCurrentChange3(val) {
			this.currentPage3 = val
			this.matchingAjax()
			const tableWrapper = this.$refs.table.$el.querySelector('.el-table__body-wrapper');
			if (tableWrapper) {
				tableWrapper.scrollTop = 0;
			}
		},
		inventoryAjax() {
			var obj = {
				loginRoleId: this.str.rid,
			}
			ajaxPost(
				Baseurl + 'inventoryController/selectInventoryCopyByRoleId',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.ReturninventoryList = res.data.data.inventorys
					this.ReturninventoryList1 = res.data.data.mallInventorys
					if (this.ReturninventoryList.length > 0) {
						this.submitdisabled = false
					} else {
						this.submitdisabled = true
					}
				} else {
					this.$message.error(res.data.data)
				}
			})
			
		},
		delSave(val) {
			// console.log(val)
			var obj = {
				id: val.id,
			}
			ajaxPost(
				Baseurl + 'inventoryController/deleteInventoryCopyById',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.inventoryAjax()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		cancel() {
			this.$confirm('如果没有过提交，以上采购单将无法入库', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				var obj = {
					loginRoleId: this.str.rid,
				}
				ajaxPost(
					Baseurl + 'inventoryController/deleteInventoryCopyByRoleId',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.inventoryAjax()
						this.$message('已取消提交')
					} else {
						this.$message.error(res.data.data)
					}
				})
				this.innerVisibles = false
			})
		},
		submit() {
			this.$alert(
				'<p>提交之后，将按照当前的采购方案进行入库核对</p><p>提交后，该采购方案将无法更改</p><p>是否确认提交</p>',
				'提示',
				{
					dangerouslyUseHTMLString: true,
					showCancelButton: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}
			).then(() => {
				this.innerVisibles = false
				console.log(this.multipleSelection.map(item => item.id))
				var obj = {
					companyId: this.str.company_id,
					roleId: this.str.rid,
					purchaseDemandIds: this.multipleSelection.map(item =>item.id),
					inventorys: this.ReturninventoryList,
					mallInventorys: this.ReturninventoryList1,
					codReturns: this.tuiTable
				}
				console.log(obj)
				ajaxPost(
					Baseurl +
					'inventoryController/saveDemandListInInventoryOperate',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							type: 'success',
							message: '提交成功!',
						})
						this.search()
						this.search1()
					} else {
						this.$message.error(res.data.data)
					}
					this.innerVisibles = false
				})
			})
		},

		getListCountry() {
			const API =
				Baseurl +
				'logisticsConfigurationController/selectLogisticsCountryList'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listCountry = data
				}
			})
		},
		popoverShows(row) {
			ajaxPost(Baseurl + 'logisticsController/getOrderOperateLog', {
				orderId: row.orderId,
			}).then((res) => {
				if (res.data.code == 200) {
					if (res.data.data.length>3) {
						this.activities = res.data.data.slice(-3)
					} else {
						this.activities = res.data.data
					}
				}
			})
		},
		SelectLogistics1(val) {
			this.morePurchaseFrom.logisticsCompany = val.logisticsCompanyName
			this.morePurchaseFrom.companyCode = val.logisticsCompanyCode
		},
		SelectTrack17Logistics1(val) {
			if(val) {
				this.morePurchaseFrom.logisticsCompany = val.nameCn
				this.morePurchaseFrom.companyCode = val.key
			}
		},
		SelectLogistics2(index) {
			this.demandList[index].logisticsCompany = this.demandList[index].logisticsCompany.logisticsCompanyName
			this.demandList[index].companyCode = this.demandList[index].logisticsCompany.logisticsCompanyCode
		},
		SelectTrack17Logistics2(index) {
			this.demandList[index].logisticsCompany = this.demandList[index].logisticsCompany.nameCn
			this.demandList[index].companyCode = this.demandList[index].logisticsCompany.key
		},
		SelectTrack17Logistics3(index) {
			// console.log(this.editAllPurchase[index].logisticsCompany);
			this.editAllPurchase[index].companyCode = this.Track17Logistics.filter(x => x.nameCn == this.editAllPurchase[index].logisticsCompany.nameCn)[0].key
			this.editAllPurchase[index].logisticsCompany = this.editAllPurchase[index].logisticsCompany.nameCn
		
		},
		SelectLogistics3(val) {
			this.asyncObj.logisticsCompany = val.logisticsCompanyName
			this.asyncObj.companyCode = val.logisticsCompanyCode
		},
		AddPurchaseb() {
			if (
				this.morePurchaseFrom.internalConveyNumber == '' &&
				this.morePurchaseFrom.logisticsCompany !== ''
			) {
				this.$message.error('物流公司和运单号码必须同时填写')
				return
			} else if (
				this.morePurchaseFrom.internalConveyNumber !== '' &&
				this.morePurchaseFrom.logisticsCompany == ''
			) {
				this.$message.error('物流公司和运单号码必须同时填写')
				return
			} else if (Number(this.morePurchaseFrom.actualRefund) < Number(this.morePurchaseFrom.otherPrice)) {
				this.$message.error('实际退款不能小于退款费用/运营退款')
				return
			}
			this.isLoading = true
			let list = []
			this.multipleSelection.map(item => {
				list.push({
					companyId: this.str.company_id,
					purchaseRoleId: this.str.rid,
					roleId: this.str.rid,
					amazonOrderId: item.amazonOrderId,
					orderId: item.orderId,
					purchaseDemandId: item.id,
					purchaseModel: item.purchaseDemand,
					purchaseFrom: '1',
					...this.morePurchaseFrom
				})
			})
			ajaxPost(
				Baseurl + 'purchaseController/batchInsertPurchase',
				list
			).then((res) => {
				if (res.data.code == 200) {
					this.isLoading = false
					this.$message({ message: '保存成功', type: 'success' })
					this.search()
					this.search1()
					this.AddinnerVisible = false
				} else {
					this.$message.error(res.data.data)
					this.isLoading = false
					this.search()
					this.search1()
					this.AddinnerVisible = false
				}
			})
		},
		purchaseAll() {
			if (this.allPurchase) {
				this.$message.error("批量采购只能用在未采购并且未提交的订单使用！")
				return
			}
			this.AddinnerVisible = true
		},
		purchaseMore() {
			this.purchaseMoreVisible = true
			let list = []
			if (this.multipleSelection && this.multipleSelection.length) {
				this.multipleSelection.map(item => {
					let obj = {
						amazonOrderId: item.amazonOrderId,
						orderId: item.orderId,
						purchaseDemandId: item.id,
						purchaseDemand: item.purchaseDemand,
						variantSkuItemList: []
					}
					if (item.productInfos && item.productInfos.length) {
						item.productInfos.map(ele => {
							if (ele.variantSkuList && ele.variantSkuList.length) {
								ele.variantSkuList.map(e => {
									obj.variantSkuItemList.push({
										sku: ele.sku,
										variantSku: e,
										quantityOrdered: ele.quantityOrdered
									})
								})
							}
						})
					}
					if (item.outInterceptStatus === 0 && item.status === "未采购" && item.buttonStatus === 1 && obj.variantSkuItemList.length) {
						list.push(obj)
					}
					// if (!obj.variantSkuItemList.length) {
					// 	delete obj.variantSkuItemList
					// }
					// list.push(obj)
				})
				this.moreLoading = true
				ajaxPost(
					Baseurl +
					'purchaseController/statisticalPurchasePurchaseDemand',
					list
				).then((res) => {
					this.moreLoading = false
					if (res.data.code === 200) {
						this.moreTableData = res.data.data
					} else {
						this.$message.error(res.data.data)
					}
				}).catch(() => {
					this.$message.error('服务器异常')
					this.moreLoading = false
				})
			}
		},
		editMore(row) {
			this.billsMoreVisible = true
			this.demandList = []
			if (row.purchaseDemandInfoList && row.purchaseDemandInfoList.length) {
				row.purchaseDemandInfoList.map(item => {
					let purchasePrice = ''
					if (item.demandCount && row.systemVariantDetailVO.estimatedPurchasePrice) {
						purchasePrice = Number(row.systemVariantDetailVO.estimatedPurchasePrice) * Number(item.demandCount)
					}
					if (!purchasePrice) {
						purchasePrice = ''
					}
					this.demandList.push({
						companyId: this.str.company_id,
						purchaseRoleId: this.str.rid,
						roleId: this.str.rid,
						purchaseFrom: '1',
						productVariantMarker: item.productVariantMarker,
						amazonOrderId: item.amazonOrderId,
						orderId: item.orderId,
						purchaseDemandId: item.purchaseDemandId,
						demandCount: item.demandCount,
						purchaseModel: item.purchaseDemand,
						purchasePrice,
						rebatePrice: '',
						actualRefund: '',
						otherPrice: '',
						purchaseTypeCode: '',
						logisticsCompany: '',
						internalConveyNumber: '',
						remark: ''
					})
				})
			}
		},
		moreSet(type) {
			this.asyncType = type
			if (type == 1) {
				this.asyncObj = JSON.parse(JSON.stringify(this.demandList[0]))
			} else {
				this.asyncObj = JSON.parse(JSON.stringify(this.editAllPurchase[0]))
			}
			this.$set(this.asyncObj, 'purchaseModelBool', false)
			this.$set(this.asyncObj, 'purchasePriceBool', false)
			this.$set(this.asyncObj, 'actualRefundBool', false)
			this.$set(this.asyncObj, 'otherPriceBool', false)
			this.$set(this.asyncObj, 'logisticsCompanyBool', true)
			this.$set(this.asyncObj, 'internalConveyNumberBool', true)
			this.$set(this.asyncObj, 'remarkBool', true)
			this.$set(this.asyncObj, 'estimatedQuantityBool', true)
			this.$set(this.asyncObj, 'useQuantityBool', true)
			this.asyncVisible = true
		},
		morePartition() {
			if (!this.partition) {
				this.$message.error("请输入分割符再操作")
				return
			}
			let list = []
			this.demandList.map(item => {
				let purchaseModels = item.purchaseModel.split(this.partition)
				purchaseModels.map(ele => {
					let obj = JSON.parse(JSON.stringify(item))
					obj.purchaseModel = ele
					list.push(obj)
				})
			})
			this.demandList = list
		},
		moreClose() {
			this.billsMoreVisible = false
			this.$nextTick(() => {
				this.demandList = []
				this.partition = ''
			})
		},
		asyncClose() {
			this.asyncVisible = false
			this.$nextTick(() => {
				this.asyncObj = {}
			})
		},
		asyncSubmit() {
			let obj = JSON.parse(JSON.stringify(this.asyncObj))
			if (this.asyncType == 1) {
				this.demandList.map(item => {
					if (obj.purchaseModelBool && !item.isDisabled) {
						item.purchaseModel = obj.purchaseModel
					}
					if (obj.purchasePriceBool) {
						item.purchasePrice = obj.purchasePrice
					}
					if (obj.actualRefundBool) {
						item.actualRefund = obj.actualRefund
					}
					if (obj.otherPriceBool) {
						item.otherPrice = obj.otherPrice
					}
					if (obj.logisticsCompanyBool && !item.isDisabled) {
						item.logisticsCompany = obj.logisticsCompany
						item.companyCode = obj.companyCode
					}
					if (obj.internalConveyNumberBool && !item.isDisabled) {
						item.internalConveyNumber = obj.internalConveyNumber
					}
					if (obj.remarkBool) {
						item.remark = obj.remark
					}
					// item.purchasePrice = obj.purchasePrice
					// item.rebatePrice = obj.rebatePrice
					// item.actualRefund = obj.actualRefund
					// item.otherPrice = obj.otherPrice
					// item.purchaseTypeCode = obj.purchaseTypeCode
					// item.logisticsCompany = obj.logisticsCompany
					// item.companyCode = obj.companyCode
					// item.internalConveyNumber = obj.internalConveyNumber
					// item.remark = obj.remark
				})
			} else {
				this.editAllPurchase.map(item => {
					if (obj.purchaseModelBool && !item.isDisabled) {
						item.purchaseModel = obj.purchaseModel
					}
					if (obj.purchasePriceBool) {
						item.purchasePrice = obj.purchasePrice
					}
					if (obj.actualRefundBool) {
						item.actualRefund = obj.actualRefund
					}
					if (obj.otherPriceBool) {
						item.otherPrice = obj.otherPrice
					}
					if (obj.logisticsCompanyBool && !item.isDisabled) {
						item.logisticsCompany = obj.logisticsCompany
						item.companyCode = obj.companyCode
					}
					if (obj.internalConveyNumberBool && !item.isDisabled) {
						item.internalConveyNumber = obj.internalConveyNumber
					}
					if (obj.remarkBool) {
						item.remark = obj.remark
					}
					if (obj.estimatedQuantityBool && item.internalConveyNumber) {
						item.estimatedQuantity = obj.estimatedQuantity
					}
					if (obj.useQuantityBool && item.internalConveyNumber) {
						item.useQuantity = obj.useQuantity
					}
					// item.purchasePrice = obj.purchasePrice
					// item.rebatePrice = obj.rebatePrice
					// item.actualRefund = obj.actualRefund
					// item.otherPrice = obj.otherPrice
					// item.purchaseTypeCode = obj.purchaseTypeCode
					// item.logisticsCompany = obj.logisticsCompany
					// item.companyCode = obj.companyCode
					// item.internalConveyNumber = obj.internalConveyNumber
					// item.remark = obj.remark
				})
			}
			this.asyncClose()
		},
		moreSubmit() {
			let bool1 = false
			let bool2 = false
			let bool3 = false
			this.demandList.map(item => {
				if (
					item.internalConveyNumber == '' &&
					item.logisticsCompany
				) {
					bool1 = true
				} else if (
					item.internalConveyNumber &&
					item.logisticsCompany == ''
				) {
					bool2 = true
				} else if (Number(item.actualRefund) < Number(item.otherPrice)) {
					bool3 = true
				}
			})
			if (bool1) {
				this.$message.error('物流公司和运单号码必须同时填写')
				return
			}
			if (bool2) {
				this.$message.error('物流公司和运单号码必须同时填写')
				return
			}
			if (bool3) {
				this.$message.error('实际退款不能小于退款费用/运营退款')
				return
			}
			this.moreLoading = true
			ajaxPost(
				Baseurl + 'purchaseController/batchInsertPurchase',
				this.demandList
			).then((res) => {
				this.moreLoading = false
				if (res.data.code == 200) {
					this.$message({ message: '保存成功', type: 'success' })
					this.search()
					this.search1()
					this.purchaseMore()
					this.moreClose()
				} else {
					this.$message.error(res.data.data)
				}
			}).catch(() => {
				this.$message.error('服务器异常，请联系客服')
				this.moreLoading = false
			})
		},
		submitRemark() {
			let bool = false
			this.remarkList.forEach(item => {
				if (!item) bool = true
			})
			if (bool) {
				this.$message.error("请填写采购备注")
				return
			}
			let { company_id } = JSON.parse(localStorage.getItem("role"));
			let remarkList = this.remarkList.join(",")
			window.open(`${Baseurl}/purchaseController/exportPurchaseDetails?company_id=${company_id}&remarkList=${remarkList}`, 'target');
			setTimeout(() => {
				this.exportDetail = false
				this.$nextTick(() => {
					this.remarkList = ['']
				})
			}, 500)
		},
		closeRemark() {
			this.remarkList = ['']
			this.exportDetail = false
		},
		addRemark() {
			this.remarkList.push('')
		},
		removeRemark(index) {
			this.remarkList.splice(index, 1)
		},
		exportShow() {
			ajaxPost(Baseurl + 'companyController/getCompanyIdsApplyOrderExport').then((res) => {
				let { company_id } = JSON.parse(localStorage.getItem("role"));
				this.exportBool = res.data.data.includes(company_id);
				this.showTuiBool = res.data.data.includes(this.str.company.id)
			})
		},
		TypeList() {
			var itemCode = {
				itemCode: 'HYXUN0000001',
			}
			ajaxPost(
				Baseurl + 'purchaseController/selectItemList',
				itemCode
			).then((res) => {
				this.selectType = res.data.data
			})
		},
		refresh() {
			this.search()
			this.search1()
			this.SelectTheStore()
			this.search4()
			// console.log('刷新完成')
		},
		SelectTheStore() {
			var param = {
				rid: this.str.rid,
				system: this.str.system,
			}
			ajaxPost(
				Baseurl + 'sellerController/selectMyFineShopByRid',
				param
			).then((res) => {
				var sellerInfos = res.data.data
				var newArr = []
				var num = 0
				for (var i = 0; i < sellerInfos.length; i++) {
					var shop = sellerInfos[i].countryMarks;
					const state = sellerInfos[i]['state'];
					for (var j = 0; j < shop.length; j++) {
						shop[j]['state1'] = state;
						newArr[num] = shop[j]
						num++
					}
				}
				console.log(newArr);
				this.ShopList = newArr
			})
		},
		handleCommand1(val) {
			var obj = {
				purchases: this.multipleSelection,
				orderMarkId: val,
			}
			ajaxPost(
				Baseurl + 'purchaseController/insertPurchaseMark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.search1()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		handleCommand2(val) {
			var obj = {
				purchases: this.multipleSelection,
				orderMarkId: val,
			}
			ajaxPost(
				Baseurl + 'orderController/insertOrderPurchaseMarkInPurchase',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.search()
					this.search1()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		handleCommand3(val) {
			var obj = {
				purchaseDemands: this.multipleSelection,
				orderMarkId: val,
			}
			ajaxPost(
				Baseurl + 'orderController/insertOrderPurchaseMarkInDemand',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.search()
					this.search1()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		handleClose1(val, tag) {
			var obj = {
				orderMarkId: tag.itemTypeId,
				purchaseMark: val.purchaseMark,
				id: val.id,
			}
			ajaxPost(
				Baseurl + 'purchaseController/deletePurchaseMark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.search1()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		handleClose2(val, tag) {
			var obj = {
				orderMarkId: tag.itemTypeId,
				purchaseMark: val.orderPurchaseMark,
				channelMark: val.channelMark,
				id: val.orderId,
				orderMark: val.orderMark,
			}
			ajaxPost(
				Baseurl + 'orderController/deleteOrderPurchaseMark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.search()
					this.search1()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		handleClose3(val, tag) {
			var obj = {
				orderMarkId: tag.itemTypeId,
				purchaseMark: val.orderPurchaseMark,
				channelMark: val.channelMark,
				id: val.orderId,
				orderMark: val.orderMark,
			}
			ajaxPost(
				Baseurl + 'orderController/deleteOrderPurchaseMark',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.search()
					this.search1()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		sortByKey(array, key) {
			return array.sort(function (a, b) {
				var x = a[key]
				var y = b[key]
				return x < y ? -1 : x > y ? 1 : 0
			})
		},
		orderTag() {
			var obj = { itemCode: 'HYXUN0000013' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList1 = res.data.data
						this.sortByKey(this.colorList1, 'itemTypeIdInteger')
					}
				}
			)
		},
		//订单、订单号标签
		orderTagStatus() {
			var obj = { itemCode: 'HYXUN0000010' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList3 = res.data.data
						this.sortByKey1(this.colorList3, 'itemTypeIdInteger')
					}
				}
			)
		},
		sortByKey1(array, key) {
			array.sort((a, b) => {
			const keyA = parseInt(a[key]);
			const keyB = parseInt(b[key]);
			return keyA - keyB;
		});
		},
		//订单、订单号标签
		orderTagStatus1() {
			var obj = { itemCode: 'HYXUN0000015' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						let obj = {};
						res.data.data.forEach(item => {
							obj[item.itemTypeId] = item
						});
						this.colorList4 = obj
					}
				}
			)
		},
		radiochange1(val) {
			this.purchaseMark = val
			this.search1()
		},
		handleClick(tab, event) {
			// this.$nextTick(() => {
			// 	this.$refs.table1.doLayout();
			//  this.syncRowHeights()
			// })
			// console.log(tab, event);
		},
		shopChange(value) {
			// this.ruleForm.shopName = value
			this.strSeller.shopIds = [value]
			// console.log(this.ruleForm.shopName)
		},
		PurchasingStatus(value) {
			this.ruleForm.status = value
			// console.log(this.ruleForm.status)
		},
		PurchasingStatus1(value) {
			this.ruleForm.status1 = value
			// console.log(this.ruleForm.status)
		},
		ProcurementType(value) {
			this.ruleForm.type = value
			console.log(this.ruleForm.type)
		},
		edit(e) {
			this.$refs.Orderpurchaseedit.init(e)
		},
		edit1(e) {
			this.$refs.PurchasingDocuments.init(e)
		},
		edit4(e) {
			this.$refs.AlibabaLogisticsEdit.init(e)
		},
		startTime(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 00:00:00'
			this.ruleForm.startTimeString = datetime
			console.log(this.ruleForm.startTimeString)
		},
		endTime(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 23:59:59'
			this.ruleForm.endTimeString = datetime
			console.log(this.ruleForm.endTimeString)
		},

		startTime1(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 00:00:00'
			this.ruleForm.startTimeString1 = datetime
			console.log(this.ruleForm.startTimeString)
		},
		endTime1(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 23:59:59'
			this.ruleForm.endTimeString1 = datetime
			console.log(this.ruleForm.endTimeString)
		},
		startTime4(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 00:00:00'
			this.ruleForm.startTime = datetime
		},
		endTime4(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 23:59:59'
			this.ruleForm.endTime = datetime
		},
		searchForm() {
			this.currentPage = 1
			this.search()
		},
		search() {
			var begin = this.ruleForm.startTimeString
			if (begin == null || begin == '') {
				begin = ''
			} else {
				begin =
					new Date(this.ruleForm.startTimeString)
						.toLocaleDateString()
						.replace(/\//g, '-') +
					' ' +
					new Date(this.ruleForm.startTimeString)
						.toTimeString()
						.substr(0, 8)
			}
			var end = this.ruleForm.endTimeString
			if (end == null || end == '') {
				end = ''
			} else {
				end =
					new Date(this.ruleForm.endTimeString)
						.toLocaleDateString()
						.replace(/\//g, '-') +
					' ' +
					new Date(this.ruleForm.endTimeString)
						.toTimeString()
						.substr(0, 8)
			}
			this.loading = true
			var searchobj = {
				page: this.currentPage,
				size: this.size,
				// shopName: this.ruleForm.shopName,
				startTimeString: begin,
				endTimeString: end,
				status: this.ruleForm.status,
				type: this.ruleForm.type,
				buttonStatus: this.ruleForm.buttonStatus,
				searchString: this.ruleForm.searchString,
				countryMark: this.ruleForm.countryMark,
				outInterceptStatus: this.ruleForm.outInterceptStatus,
				timeType: this.ruleForm.timeType,
				rid: this.str.rid,
				system: this.str.system,
				shopIds: this.strSeller.shopIds,
				orderPurchaseMark: this.orderPurchaseMark3,
			}
			if(this.ruleForm.searchString2s){
				this.$set(searchobj, 'searchStrList', this.ruleForm.searchString2s.split(' '))
			}
			ajaxPost(
				Baseurl + 'purchaseDemandController/selectPurchaseDemandList',
				searchobj
			).then((res) => {
				this.tableData = res.data.data.list
				this.$nextTick(() => {
					this.syncRowHeights()
				})
				const kcSearchArr = [];
				this.total = res.data.data.total;
				const dataMap = {};
				for(var i=0;i<this.tableData.length;i++){
					for(var a=0;a<this.platforms.length;a++){
						if(this.tableData[i].source==this.platforms[a].itemTypeId){
							this.tableData[i].sourceclass=this.platforms[a].itemTypeName;
						}
					}
					const skuArr = this.tableData[i] ? this.tableData[i]['productInfos'].map(item => item.sku) : [];
					dataMap[this.tableData[i]['orderId']] = {
						index: i,
						skuArr: skuArr,
					};
					const item = {
						orderId: this.tableData[i]['orderId'],
						shopId: this.tableData[i]['shopId'],
						productInfos: this.tableData[i] ? this.tableData[i]['productInfos'].map(item => item.sku) : [],
					};
					kcSearchArr.push(item);
				}
				ajaxPost(
					Baseurl + 'purchaseDemandController/getInventoryInfoList',
					kcSearchArr
				).then((res) => {
					if(res.data.code == 200){
						const d = res.data.data;
						for(let i = 0; i < d.length; i++){
							const index = dataMap[d[i]['orderId']]['index'];
							const skuArr = dataMap[d[i]['orderId']]['skuArr'];
							if(d[i]['results']){
								d[i]['results'].sort((a,b) => skuArr.indexOf(a.sku) - skuArr.indexOf(b.sku));
							}
							this.$set(this.tableData[index], 'inventoryInfo', d[i]['results'])
						}
					}
				})
				this.loading = false
			})
		},

		searchForm1() {
			this.currentPage1 = 1
			this.search1()
		},
		search1() {
			var begin = this.ruleForm.startTimeString1
			if (begin == null || begin == '') {
				begin = ''
			} else {
				begin =
					new Date(this.ruleForm.startTimeString1)
						.toLocaleDateString()
						.replace(/\//g, '-') +
					' ' +
					new Date(this.ruleForm.startTimeString1)
						.toTimeString()
						.substr(0, 8)
			}
			var end = this.ruleForm.endTimeString1
			if (end == null || end == '') {
				end = ''
			} else {
				end =
					new Date(this.ruleForm.endTimeString1)
						.toLocaleDateString()
						.replace(/\//g, '-') +
					' ' +
					new Date(this.ruleForm.endTimeString1)
						.toTimeString()
						.substr(0, 8)
			}
			this.loading1 = true
			var searchobj = {
				page: this.currentPage1,
				size: this.size1,
				startTimeString: begin,
				endTimeString: end,
				purchaseStatus: this.ruleForm.status1,
				isMultipleDocuments: this.ruleForm.isMultipleDocuments,
				checkResult: this.ruleForm.checkResult,
				searchString: this.ruleForm.searchString1,
				purchaseRoleId: this.str.rid,
				purchaseMark: this.purchaseMark,
				orderPurchaseMark: this.orderPurchaseMark,
				outInterceptStatus: this.ruleForm.outInterceptStatus1,
				timeType: this.ruleForm.timeType1,
				searchStrList: [],
				noCost: this.ruleForm.noCost,
			}
			if (this.ruleForm.searchString1s) {
				this.$set(searchobj, 'searchStrList', this.ruleForm.searchString1s.split(' '))
			}
			ajaxPost(
				Baseurl + 'purchaseController/selectPurchaseList',
				searchobj
			).then((res) => {
				this.tableData1 = res.data.data.pageInfo.list
				this.total1 = res.data.data.pageInfo.total
				this.balance = res.data.data.balance
				this.loading1 = false
				// console.log(res.data.data)
			})
		},
		searchForm4() {
			this.currentPage4 = 1
			this.search4()
		},
		search4() {
			this.loading = true
			var searchobj = {
				page: this.currentPage4,
				size: this.size4,
				startTime: this.ruleForm.startTime,
				endTime: this.ruleForm.endTime,
				companyId: this.str.company_id,
				searchStr: this.ruleForm.searchStr,
				// searchStr: '1987077759690008691',
				
			}
			ajaxPost(
				Baseurl + 'alibabaLogisticsInfoController/selectAlibabaLogisticsInfoList',
				searchobj
			).then((res) => {
				this.tableData4 = res.data.data.list
				this.total4 = res.data.data.total
				this.loading = false
			})
		},
		resetFprm() {
			this.strSeller = JSON.parse(localStorage.getItem('sellerInfo'))
			this.currentPage = 1
			this.ruleForm.shopName = null
			this.ruleForm.countryMark = null
			this.ruleForm.startTimeString = null
			this.ruleForm.endTimeString = null
			this.ruleForm.status = null
			this.ruleForm.type = null
			this.ruleForm.buttonStatus = null
			this.ruleForm.searchString = null;
			this.ruleForm.searchString2s = '';
			this.ruleForm.outInterceptStatus = 2
				; (this.ruleForm.timeType = 2),
					(this.ruleForm.resource3 = ''),
					(this.orderPurchaseMark3 = ''),
					this.search()
			this.search1()
		},
		resetFprm1() {
			this.currentPage1 = 1
			this.ruleForm.startTimeString1 = null
			this.ruleForm.endTimeString1 = null
			this.ruleForm.status1 = null
			this.ruleForm.isMultipleDocuments = null
			this.ruleForm.checkResult = null
			this.ruleForm.searchString1 = null
			this.ruleForm.outInterceptStatus1 = 2
			this.ruleForm.timeType1 = 3
			this.ruleForm.noCost = false
			this.ruleForm.searchString1s = ''
				; (this.ruleForm.resource1 = ''),
					(this.ruleForm.resource2 = ''),
					(this.orderPurchaseMark = ''),
					(this.purchaseMark = '')
			this.search()
			this.search1()
		},
		resetFprm4() {
			this.currentPage4 = 1
			this.ruleForm.startTime = null
			this.ruleForm.endTime = null
			this.ruleForm.searchStr = null
			this.search4()
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`)
			this.size = val
			this.search()
		},
		handleSizeChange1(val) {
			this.size1 = val
			this.search1()
		},
		handleSizeChange2(val) {
			this.size2 = val
			var roleId = {
				page: this.currentPage2,
				size: this.size2,
				roleId: this.str.rid,
			}
			ajaxPost(
				Baseurl + 'reserveFundController/selectReserveFundsByRoleId',
				roleId
			).then((res) => {
				this.pettyCash = res.data.data.list
				if (this.pettyCash.length) {
					this.pettyCash.forEach((item) => {
						if (item.firstStatus == null) item.firstStatus = 1
					})
				}
				this.total2 = res.data.data.total
				console.log(this.total2)
			})
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`)
			this.currentPage = val
			this.search()
		},
		handleCurrentChange1(val) {
			this.currentPage1 = val
			this.search1()
		},
		handleCurrentChange2(val) {
			this.currentPage2 = val
			var roleId = {
				page: this.currentPage2,
				size: this.size2,
				roleId: this.str.rid,
			}
			ajaxPost(
				Baseurl + 'reserveFundController/selectReserveFundsByRoleId',
				roleId
			).then((res) => {
				this.pettyCash = res.data.data.list
				if (this.pettyCash.length) {
					this.pettyCash.forEach((item) => {
						if (item.firstStatus == null) item.firstStatus = 1
					})
				}
				this.total2 = res.data.data.total
			})
		},
		handleSizeChange4(val) {
			this.size4 = val
			this.search4()
		},
		handleCurrentChange4(val) {
			this.currentPage4 = val
			this.search4()
		},
		Reservefund() {
			this.dialogTableVisible = true
			var roleId = {
				page: this.currentPage2,
				size: this.size2,
				roleId: this.str.rid,
			}
			ajaxPost(
				Baseurl + 'reserveFundController/selectReserveFundsByRoleId',
				roleId
			).then((res) => {
				this.pettyCash = res.data.data.list
				if (this.pettyCash.length) {
					this.pettyCash.forEach((item) => {
						if (item.firstStatus == null) item.firstStatus = 1
					})
				}
				this.total2 = res.data.data.total
				// console.log(res.data.data)
			})
		},
		Reservefund1() {
			this.PettyCashApplication = true
		},
		pettyCashSubmit() {
			var obj = {
				receiptMoney: this.receiptMoney,
				applyRoleId: this.str.rid,
				companyId: this.str.company_id,
				remark: this.remark,
			}
			ajaxPost(
				Baseurl + 'reserveFundController/insertReserveFundApply',
				obj
			).then((res) => {
				console.log(res.data)
				if (res.data.code == 200) {
					this.$message({
						message: '申请备用金成功',
						type: 'success',
					})
					this.disabled = true
				} else {
					this.$message.error('申请备用金失败')
					this.disabled = false
				}
			})
			this.PettyCashApplication = false
		},
		returnAddress() {
			this.Shipping = true
			this.AddressList()
		},
		AddressList() {
			var obj = {
				companyId: this.str.company_id,
			}
			ajaxPost(
				Baseurl +
				'receivingAddressController/selectReceivingAddressByCompanyId',
				obj
			).then((res) => {
				// console.log(res.data);
				this.AddressData = res.data.data
				// console.log(JSON.parse(JSON.stringify(this.AddressData)));
				this.radioId = ''
				for (var i = 0; i < this.AddressData.length; i++) {
					if (this.AddressData[i].isDefault === 1) {
						//   console.log(JSON.parse(JSON.stringify(this.AddressData[i])));
						this.radioId = this.AddressData[i].id
					}
				}
			})
		},
		radio(val) {
			this.radioId = val
		},
		AddAddress() {
			var obj = {
				companyId: this.str.company_id,
				receivingAddress: this.receivingAddress,
				recipientName: this.recipientName,
				recipientTelephone: this.recipientTelephone,
				remarks: this.remarks ? this.remarks.trim() : '',
			}
			if (obj.receivingAddress == '') {
				this.$message.warning('请填写收件人地址')
				return
			} else if (obj.recipientName == '') {
				this.$message.warning('请填写收件人姓名')
				return
			} else if (obj.recipientTelephone == '') {
				this.$message.warning('请填写收件人电话')
				return
			}

			ajaxPost(
				Baseurl + 'receivingAddressController/insertReceivingAddress',
				obj
			).then((res) => {
				// console.log(res.data);
				if (res.data.code === 200) {
					this.$message({
						message: '新增收货地址成功',
						type: 'success',
					})
					this.AddressList()
				} else {
					this.$message.error(res.data.data)
				}
				this.innerVisible = false
				this.receivingAddress = ''
				this.recipientName = ''
				this.recipientTelephone = ''
				this.remarks = '';
			})
		},
		EditAddressShow(val) {
			this.innerVisible1 = true
			this.receivingAddress1 = val.receivingAddress
			this.recipientName1 = val.recipientName
			this.recipientTelephone1 = val.recipientTelephone
			this.remarks1 = val.remarks
			this.AddressId = val.id
		},
		EditAddress() {
			var obj = {
				companyId: this.str.company_id,
				receivingAddress: this.receivingAddress1,
				recipientName: this.recipientName1,
				recipientTelephone: this.recipientTelephone1,
				remarks: this.remarks1 ? this.remarks1.trim() : '',
				id: this.AddressId,
			}
			if (obj.receivingAddress == '') {
				this.$message.warning('请填写收件人地址')
				return
			} else if (obj.recipientName == '') {
				this.$message.warning('请填写收件人姓名')
				return
			} else if (obj.recipientTelephone == '') {
				this.$message.warning('请填写收件人电话')
				return
			}
			ajaxPost(
				Baseurl + 'receivingAddressController/updateReceivingAddress',
				obj
			).then((res) => {
				// console.log(res.data);
				if (res.data.code === 200) {
					this.$message({
						message: '修改收货地址成功',
						type: 'success',
					})
					this.AddressList()
				} else {
					this.$message.error(res.data.data)
				}
				this.innerVisible1 = false
			})
		},
		DelAddress(val) {
			this.$confirm('确定删除当前收货地址?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					var obj = {
						id: val.id,
					}
					ajaxPost(
						Baseurl +
						'receivingAddressController/deleteReceivingAddress',
						obj
					).then((res) => {
						// console.log(res.data);
						if (res.data.code === 200) {
							this.$message({
								message: '删除当前收货地址成功',
								type: 'success',
							})
							this.AddressList()
						} else {
							this.$message.error(res.data.data)
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		defaultAddress() {
			console.log(this.radioId)
			// return;
			var obj = {
				id: this.radioId,
				companyId: this.str.company_id,
			}
			if (obj.id == '') {
				this.$message.warning('请选择一条设为默认地址')
				return
			}
			ajaxPost(
				Baseurl +
				'receivingAddressController/updateReceivingAddressIsDefault',
				obj
			).then((res) => {
				if (res.data.code === 200) {
					this.$message({
						message: '设置默认收货地址成功',
						type: 'success',
					})
					this.AddressList()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		handleSelectionChange(val) {
			this.allPurchase = true
			if (val.every(x => x.buttonStatus == 1) && val.every(x => x.status == '未采购') && val.length) {
				this.allPurchase = false
			} else {
				this.allPurchase = true
			}
			this.multipleSelection = val
			if (this.multipleSelection.length > 0) {
				this.EditDisabled = false
			}
			if (this.multipleSelection.length === 0) {
				this.EditDisabled = true
			}
			if (this.multipleSelection === []) {
				this.colordisabled = true
			} else if (this.multipleSelection.length == 0) {
				this.colordisabled = true
			} else {
				this.colordisabled = false
			}
		},
		EditSome() {
			this.batchEditor = true
			this.editAllPurchase = []
			this.multipleSelection.map(item => {
				let obj = {
					id: item.id,
					companyId: this.str.company_id,
					purchaseRoleId: this.str.rid,
					roleId: this.str.rid,
					amazonOrderId: item.amazonOrderId,
					rebatePrice: item.rebatePrice,
					otherPrice: item.otherPrice,
					actualRefund: item.actualRefund,
					logisticsCompany: item.logisticsCompany,
					remark: item.remark,
					purchasePrice: item.purchasePrice,
					purchaseTypeCode: item.purchaseTypeCode,
					companyCode: item.companyCode,
					purchaseModel: item.purchaseModel,
					queryTrackSwitch: item.queryTrackSwitch,
					isDisabled: false,
					isContent: '请填写物流公司/运单号码',
					isContens: '完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对'
				}
				if (item.checkResult != 4) {
					obj.isDisabled = true
					obj.isContent = '该采购单已经入库，国内单号和物流公司不能修改！'
					obj.isContens = '已经入库，不能修改！'
				}
				if (item.logisticsCompany) {
					this.$set(obj, 'companyCode', item.companyCode)
				}
				if (item.logisticsInformation && item.logisticsInformation.estimatedQuantity) {
					this.$set(obj, 'estimatedQuantity', item.logisticsInformation.estimatedQuantity)
				} else {
					this.$set(obj, 'estimatedQuantity', 1)
				}
				if (item.logisticsInformation && item.logisticsInformation.useQuantity) {
					this.$set(obj, 'useQuantity', item.logisticsInformation.useQuantity)
				} else {
					this.$set(obj, 'useQuantity', 1)
				}
				if (item.logisticsInformation && item.logisticsInformation.estimatedId) {
					this.$set(obj, 'estimatedId', item.logisticsInformation.estimatedId)
				} else {
					this.$set(obj, 'estimatedId', '')
				}
				if (item.logisticsInformation && item.logisticsInformation.internalConveyNumber) {
					this.$set(obj, 'internalConveyNumber', item.logisticsInformation.internalConveyNumber)
				} else {
					this.$set(obj, 'internalConveyNumber', item.internalConveyNumber)
				}
				this.editAllPurchase.push(obj)
			})
		},
		getQuantity(index) {
			if (this.editAllPurchase[index].internalConveyNumber) {
				var obj = {
					internalConveyNumber: this.editAllPurchase[index].internalConveyNumber
				}
				ajaxPost(
					Baseurl + 'logisticsInformationController/selectLogisticsInformation',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						if (res.data.data && res.data.data.estimatedQuantity) {
							this.editAllPurchase[index].estimatedId = res.data.data.id
							this.editAllPurchase[index].estimatedQuantity = Number(res.data.data.estimatedQuantity)
						}
					} else {
						this.$message.error(res.data.data || res.data.message)
					}
				})
			}
		},
		AddEdit() {
			let bool1 = false
			let bool2 = false
			let bool3 = false
			this.editAllPurchase.map(item => {
				if (item.internalConveyNumber) {
					let obj = {
						internalConveyNumber: item.internalConveyNumber,
						estimatedQuantity: item.estimatedQuantity,
						useQuantity: item.useQuantity
					}
					this.$set(item, 'logisticsInformation', obj)
				}
				if (
					item.internalConveyNumber == '' &&
					item.logisticsCompany
				) {
					bool1 = true
				} else if (
					item.internalConveyNumber &&
					item.logisticsCompany == ''
				) {
					bool2 = true
				} else if (Number(item.actualRefund) < Number(item.otherPrice)) {
					bool3 = true
				}
			})
			if (bool1) {
				this.$message.error('物流公司和运单号码必须同时填写')
				return
			}
			if (bool2) {
				this.$message.error('物流公司和运单号码必须同时填写')
				return
			}
			if (bool3) {
				this.$message.error('实际退款不能小于退款费用/运营退款')
				return
			}
			// console.log(this.editAllPurchase);
			this.AddEditAjax()
		},
		AddEditAjax() {
			this.batchLoading = true
			ajaxPost(
				Baseurl + 'purchaseController/batchUpdatePurchase',
				this.editAllPurchase
			).then((res) => {
				if (res.data.code === 200) {
					this.batchLoading = false
					this.batchEditor = false
					this.$message({
						message: res.data.data,
						type: 'success',
					})
					this.search1()
					const queryTrackSwitch = this.str.company.queryTrackSwitch
					if(queryTrackSwitch == 1) {
						// 注册17track
						var arrList = []
						this.editAllPurchase.forEach(item => {
							var obj = {
								number: item.internalConveyNumber,
								carrier: item.companyCode,
							}
							// 检查数组中是否已存在相同的元素
							if (!arrList.some(existingObj => JSON.stringify(existingObj) === JSON.stringify(obj))) {
								// 如果不存在相同元素，则添加到数组中
								arrList.push(obj);
							}
						})
						// console.log(arrList);

						if(arrList.length > 0) {
							ajaxPost(
								Baseurl + 'track17Controller/register',
								arrList
							).then((res) => {
								if (res.data.code == 200) {
									console.log(res.data);
								} else {
									this.$message.error(res.data.data)
								}
							})
						}
						
					}
					this.editAllPurchase = []
					// this.SavesubscribeAjax()
				} else {
					this.$message.error(res.data.data)
					this.batchLoading = false
				}
			}).catch(() => {this.batchLoading = false})
		},
		// SavesubscribeAjax(){
		//     var obj = {
		//         companyId: this.sondata.companyId,
		//         number:this.internalConveyNumber,
		//         companyCode:this.logisticsCompany.logisticsCompanyCode
		//     }
		//     ajaxPost(Baseurl + "conveyNumberQueryController/subscribe", obj).then(res => {
		//             if(res.data.code == 200){
		//                 console.log(res.data);
		//             }else{
		//                 this.$message.error(res.data.data)
		//             }
		//     });
		// },
		delivery() {
			this.deliveryAddress = true
			ajaxPost(Baseurl + 'warehouseController/selectWarehouse').then(
				(res) => {
					if (res.data.code === 200) {
						console.log(res.data)
						this.warehouseAddress = res.data.data
					}
				}
			)
		},
		queryDomesticOrderMove(item) {
			const API = Baseurl + 'conveyNumberQueryController/queryTrack'
			const paramsDate = {
				num: item.internalConveyNumber,
				companyId: item.companyId,
				com: item.companyCode,
			}
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
						// console.log(data)
					} else {
						reject(data)
					}
				})
			})
		},
		async popoverShow(item) {
			this.popoverText = '查询中...'
			this.popoverStatus = true
			try {
				if(item.queryTrackSwitch === 1) {
					// const data = await this.queryDomesticOrderMove(item)  // 快递100物流轨迹查询
					const data = await this.query17Trackinfo(item)  // 17track物流轨迹查询
					// 快递100轨迹解析逻辑
					// if (data.status === '200') {
					// 	this.popoverStatus = false
					// 	this.popoverInfo = data
					// } else {
					// 	this.popoverText = data.message || '查询失败'
					// }
					if (data.code === 0 && data.data.accepted && data.data.accepted.length > 0) {
						this.popoverStatus = false
						this.popoverInfo = data.data.accepted[0]
					} else if (data.code === 0 && data.data.rejected && data.data.rejected.length > 0) {
						this.popoverText = data.data.rejected[0].error.message
					} else {
						this.popoverText = data.message || '查询失败'
					}
				} else {
					this.popoverText = '贵司尚未开启物流轨迹查询!'
				}
				
			} catch (error) {
				this.popoverText = error || '查询失败'
			}
		},
		query17Trackinfo(item) {
			const API = Baseurl + 'track17Controller/gettrackinfo'
			const paramsDate = [{
				number: item.internalConveyNumber,
				carrier: !isNaN(item.companyCode) ? item.companyCode : null,
			}]
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		async popoverShowAdditional(item) {
			const queryTrackSwitch = this.str.company.queryTrackSwitch
			this.popoverText = '查询中...'
			this.popoverStatus = true
			try {
				if(queryTrackSwitch === 1){
					const API = Baseurl + 'track17Controller/gettrackinfo'
					const paramsData = [{
						number: item.conveyNumber,
						carrier: !isNaN(item.companyCode) ? item.companyCode : null,
					}]
					ajaxPost(API, paramsData).then(res => {
						const { code, data } = res.data;
						if (code === 200 && data.code === 0 && data.data.accepted && data.data.accepted.length > 0) {
							this.popoverStatus = false
							this.popoverInfo = data.data.accepted[0]
						} else if (code === 200 && data.code === 0 && data.data.rejected && data.data.rejected.length > 0) {
						this.popoverText = data.data.rejected[0].error.message
						} else {
							this.popoverText = data.message || '查询失败'
						}
					});
				} else {
					this.popoverText = '贵司尚未开启物流轨迹查询!'
				}
				
			} catch (error) {
				this.popoverText = error || '查询失败'
			}
		},
		async popoverShowAlibabaTrack(logisticsId, alibabaOrderId, companyId) {
			const queryTrackSwitch = this.str.company.queryTrackSwitch
			this.popoverText = '查询中...'
			this.popoverStatus = true
			try {
				if(queryTrackSwitch === 1) {
					const API = Baseurl + 'alibabaLogisticsController/getLogisticsTraceInfo'
					const paramsData = {
						logisticsId: logisticsId,
						orderId: alibabaOrderId,
						companyId: companyId,
					}
					ajaxPost(API, paramsData).then(res => {
						const { code, data } = res.data;
						if (code === 200) {
							// console.log(data);
							this.popoverStatus = false
							this.popoverInfo = data[0]
						}else{
							this.popoverText = data || '查询失败'
						}
					});
				} else {
					this.popoverText = '贵司尚未开启物流轨迹查询!'
				}
			} catch (error) {
				this.popoverText = error || '查询失败'
			}
		},
		queryDomesticOrderClick(item) {
			console.log(item)
			const inputEle = document.createElement('input')
			inputEle.readOnly = 'readOnly'
			inputEle.style.position = 'absolute'
			inputEle.style.top = document.body.scrollTop
			inputEle.style.zIndex = '-1000'
			const appEle = document.getElementById('app')
			appEle.appendChild(inputEle)
			inputEle.setAttribute('value', item.internalConveyNumber)
			inputEle.select()
			if (document.execCommand('copy')) {
				this.$confirm('复制成功，点击确定跳转快递100页面', '提示').then(
					() => {
						window.open('https://www.kuaidi100.com/')
					}
				)
			}
			appEle.removeChild(inputEle)
		},
		LogisticsAjax() {
			ajaxPost(
				Baseurl + 'logisticsController/getLogisticsCompanyList'
			).then((res) => {
				if (res.data.code == 200) {
					this.Logistics = res.data.data
				}
			})
		},
		Track17LogisticsAjax() {
			ajaxPost(
				Baseurl + 'logisticsController/getTrack17Carriers'
			).then((res) => {
				if (res.data.code == 200) {
					this.Track17Logistics = res.data.data
				}
			})
		},
		SelectLogistics(index) {
			this.editAllPurchase[index].companyCode = this.Logistics.filter(x => x.logisticsCompanyName == this.editAllPurchase[index].logisticsCompany)[0].logisticsCompanyCode
		},
		// 国内物流
		chanDomestic(val) {
			this.domesticvalue = val
		},
		//国内订单标签
		domesticTag() {
			var obj = { itemCode: 'HYXUN0000011' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList2 = res.data.data
						this.sortByKey(this.colorList2, 'itemTypeIdInteger')
					}
				}
			)
		},
		radiochange2(val) {
			this.orderPurchaseMark = val
			this.search1()
		},
		radiochange3(val) {
			this.orderPurchaseMark3 = val
			this.search()
		},
		handleUploadExcelDialogClose() {
      this.dialogVisible = false
      this.listFile = []
      this.errorList = ''
			this.returnList = []
    },
		handleUploadExcelSuccess({ results, header, fileName }) {
      let returnList = results.map(item => ({
        remark: item.备注,
        internalConveyNumber: item.国内单号,
        logisticsCompany: item.物流公司,
        estimatedQuantity: item.包裹总计,
      }))
      this.returnList.push(...returnList)
      this.listFile.push({fileName})
    },
		downloadTemplate() {
      const a = document.createElement('a')
      a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%9B%BD%E5%86%85%E8%BF%90%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%9B%BD%E5%86%85%E8%BF%90%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      a.click()
      this.$message.success('正在下载...')
    },
    handleUploadExcelSubmit() {
			let obj = {
				companyId: this.str.company_id,
				purchases: this.returnList
			}
      this.btnLoading = true
      ajaxPost(Baseurl + 'purchaseController/importDomesticWaybillInformation', obj).then((res) => {
        this.btnLoading = false
        if (res.data.code == 200) {
          this.$message.success("成功导入"+res.data.data.successCount+"条数据")
          if (res.data.data.errorList.length) {
            this.errorList = res.data.data.errorList.join(",")
          } else {
            this.dialogVisible = false
            this.listFile = []
            this.errorList = ''
						this.returnList = []
          }
          this.search1()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
	},
}
</script>

<style lang="scss" scoped>
// .morePurchase /deep/ .el-dialog__body {
// 	height: 700px;
// }

.PurchaseOrder {
	padding-bottom: 20px;
	margin-bottom: 20px;
	border-bottom: 1px solid #999;
	&.last {
		padding-bottom: 0;
		margin-bottom: 0;
		border-bottom: none;
	}
}
/deep/ {
	.layout .layout-section ::-webkit-scrollbar {
		width: 10px;
		height: 10px;
		background-color: #b71e1e;
	}

	.PurchaseOrder .el-form-item {
		margin-bottom: 10px;
	}

	.el-form-item__content {
		margin-left: 0px !important;
	}

	.el-tag--dark {
		border: 0;
	}

	.logistics .el-input__inner {
		border-radius: 0px 4px 4px 0px !important;
	}
}

.information {
	width: 98%;
	overflow: hidden;
}

.scope_img {
	width: 55px;
	height: 55px;

	img {
		width: 100%;
		height: 100%;
	}
}

.padding {
	padding: 10px 0;
}

.prduct_img {
	width: 500px;
	height: 500px;
}

.line-height {
	line-height: 45px;
}

.details {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px;
}

.details1 {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 10px;
}

.details_left {
	width: 30%;
	text-align: center;
}

.details_right {
	width: 70%;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
}

.page {
	position: fixed;
	width: 100%;
	bottom: 0;
	background-color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 50px;
}

.page1 {
	width: 100%;
	bottom: 0;
	background-color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 50px;
}

.AddAddress {
	color: #409eff;
	cursor: pointer;
}

.table-body {
	margin-top: 30px;
	width: 100%;
	border: 1px solid #eee;
	overflow: hidden;
	box-sizing: border-box;
}

.table-batch {
	width: 100%;
	overflow: hidden;
	height: 40px;
	line-height: 40px;
	padding-left: 25px;
}

.table-list {
	display: block;
}

.Memo {
	width: 25px;
	height: 25px;
}

.leix {
	background-color: #f5f7fa;
	line-height: 30px;
	padding: 5px;
	border-left: 1px solid #e4e7ed;
	border-bottom: 1px solid #e4e7ed;
	border-top: 1px solid #e4e7ed;
	color: #909399;
	border-radius: 4px 0px 0px 4px;
}

.picsImg {
	width: 80px;
}

.checkboxCol {
	/deep/ .el-checkbox {
		margin-top: 5px;
		margin-left: 5px;
	}
	&.teshu {
		/deep/ .el-checkbox {
			margin-top: -2px;
			vertical-align: 4px;
		}
	}
}
/deep/ .search-input .el-form-item__content{
	display: flex;
	align-items: center;
	.el-input{
		width: 40%;
		margin-right: 10px;
	}
	.el-button{
		height: 32px;
	}
}
/deep/ .td_detail{
	
}
.details12{
	padding: 10px;
	// height: 80px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	overflow-y: auto;
	.red{
		color: red;
	}
}
/deep/ .special-font{
	font-weight: bold;
	color: red;
}
</style>
